import { nanoid } from "nanoid";
import {
  DynamicErrorResponse,
  EnrollmentType,
  GetAccountDetailsResponse,
  GetAccountResponse,
  GetAgentDetailsResponse,
  GetAutopayEnrollmentResponse,
  GetBankNamesResponse,
  GetCallInfoResponse,
  GetCardmemberMailListResponse,
  GetClassificationCountResponse,
  GetClassificationsResponse,
  GetCreditLineIncreaseEligibilityResponse,
  GetCycleToDateTransactionsResponse,
  GetPartyRestrictionsResponse,
  GetPaymentHistoryResponse,
  GetPaymentMethodsResponse,
  GetPaymentSeriesScheduleResponse,
  GetPaymentTransactionsResponse,
  GetPermissionToDiscussResponse,
  GetPhonesResponse,
  GetSecureMailListResponse,
  GetSecureMailThreadResponse,
  GetStatementHistoryResponse,
  GetTermsResponse,
  LostStolenOptionsResponse,
  PaymentOverridesResponse,
  PaymentScriptsResponse,
  GetPhoneOptionsResponse,
  SecureMailConversationType,
  SubmitCreditLineIncreaseResponse,
  AccountSearchResult,
  CustomerInfo,
  GetChangedHistoryResponse,
  GetCitiesByZipcodeResponse,
  GetVerifiedHistoryResponse,
  StatementsResp,
  GetPaperlessSettingsResponse,
  GetCardActivationInfoResponse,
  SubmitCardActivationResponse,
  GetTextBankingServicesResponse,
  ResultDropdowns,
  ResultsDropdownsByChannel,
  ResultOption,
  NoteDetail,
  GetNotesSearchResponse,
  ListenResponse,
} from "../models";
import { addDays } from "date-fns";

export const MOCK_GET_AGENT_DETAILS_RESPONSE: GetAgentDetailsResponse = {
  roles: [
    "ach",
    "unlock",
    "usa",
    "username",
    "achPaper",
    "viewPCIData",
    "makePayment",
    "addPaymentRestriction",
    "removePaymentRestriction",
    "permissionToDiscuss",
    "cycleToDateTransactions",
    "statementHistory",
    "viewAccountNumber",
    "cli",
    "terms",
    "phones",
    "cmInfo",
    "lostStolen",
    "statements",
    "paperless",
    "cardActivation",
    "textBanking",
    "reviewAdjustments",
  ],
  isValid: true,
};

export const MOCK_ACCOUNT: GetAccountResponse = {
  currentDwbuid: "unpopulated",
  partyId: "3438",
  firstName: "Ebony",
  lastName: "Black",
  registrationDateTime: new Date("2022-08-14T02:41:00.000Z"),
};

export const MOCK_ACCOUNTS: AccountSearchResult[] = [
  {
    address: "363 W Anchor Dr Dakota Dunes, DC 57047",
    birthDate: "09/01/2000",
    cardNumberLast4: "1917",
    dwbuid: "unpopulated",
    externalStatus: "Delinquent",
    internalStatus: "",
    name: "Testroommate Vilson",
    partyId: "3438",
    registrationDateTime: "",
    ssnLast4: "",
  },
  {
    address: "363 W Anchor Dr Dakota Dunes, DC 57047",
    birthDate: "01/01/1970",
    cardNumberLast4: "V0425",
    dwbuid: "unpopulated",
    externalStatus: "Delinquent",
    internalStatus: "Charged Off",
    name: "OCL 10 Account Test",
    partyId: "3438",
    registrationDateTime: "",
    ssnLast4: "1234",
  },
  {
    address: "PO Box 1200 Dr Dakota Dunes, SD 57049",
    birthDate: "08/30/1982",
    cardNumberLast4: "V0559",
    dwbuid: "unpopulated",
    externalStatus: "",
    internalStatus: "",
    name: "Jane Doe",
    partyId: "3438",
    registrationDateTime: "",
    ssnLast4: "",
  },
];

export const MOCK_ACCOUNT_DETAILS: GetAccountDetailsResponse = {
  actionEntryPanel: [
    {
      agentCode: "315",
      resultActionEntryDate: "2026-04-16",
      resultActionEntryPosted: "114 0077 LM",
    },
    {
      agentCode: "315",
      resultActionEntryDate: "2026-04-01",
      resultActionEntryPosted: "099 0077 LM",
    },
    {
      agentCode: "215",
      resultActionEntryDate: "2026-03-04",
      resultActionEntryPosted: "072 0077 LM",
    },
    {
      agentCode: "805",
      resultActionEntryDate: "2026-01-16",
      resultActionEntryPosted: "000 0077 LM",
    },
    {
      agentCode: "805",
      resultActionEntryDate: "2026-01-14",
      resultActionEntryPosted: "000 0077 LM",
    },
    {
      agentCode: "805",
      resultActionEntryDate: "2026-01-13",
      resultActionEntryPosted: "000 CS80 LM",
    },
    {
      agentCode: "805",
      resultActionEntryDate: "2026-01-12",
      resultActionEntryPosted: "000 0077 LM",
    },
    {
      agentCode: "515",
      resultActionEntryDate: "2025-05-06",
      resultActionEntryPosted: "164 0077 LM",
    },
    {
      agentCode: "315",
      resultActionEntryDate: "2025-02-26",
      resultActionEntryPosted: "096 0077 LM",
    },
    {
      agentCode: "052",
      resultActionEntryDate: "2024-01-09",
      resultActionEntryPosted: "048 CS80 LM",
    },
    {
      agentCode: "315",
      resultActionEntryDate: "2026-04-16",
      resultActionEntryPosted: "114 0077 LM",
    },
    {
      agentCode: "315",
      resultActionEntryDate: "2026-04-01",
      resultActionEntryPosted: "099 0077 LM",
    },
    {
      agentCode: "215",
      resultActionEntryDate: "2026-03-04",
      resultActionEntryPosted: "072 0077 LM",
    },
    {
      agentCode: "805",
      resultActionEntryDate: "2026-01-16",
      resultActionEntryPosted: "000 0077 LM",
    },
    {
      agentCode: "805",
      resultActionEntryDate: "2026-01-14",
      resultActionEntryPosted: "000 0077 LM",
    },
    {
      agentCode: "805",
      resultActionEntryDate: "2026-01-13",
      resultActionEntryPosted: "000 CS80 LM",
    },
    {
      agentCode: "805",
      resultActionEntryDate: "2026-01-12",
      resultActionEntryPosted: "000 0077 LM",
    },
    {
      agentCode: "515",
      resultActionEntryDate: "2025-05-06",
      resultActionEntryPosted: "164 0077 LM",
    },
    {
      agentCode: "315",
      resultActionEntryDate: "2025-02-26",
      resultActionEntryPosted: "096 0077 LM",
    },
    {
      agentCode: "052",
      resultActionEntryDate: "2024-01-09",
      resultActionEntryPosted: "048 CS80 LM",
    },
    {
      agentCode: "315",
      resultActionEntryDate: "2026-04-16",
      resultActionEntryPosted: "114 0077 LM",
    },
    {
      agentCode: "315",
      resultActionEntryDate: "2026-04-01",
      resultActionEntryPosted: "099 0077 LM",
    },
    {
      agentCode: "215",
      resultActionEntryDate: "2026-03-04",
      resultActionEntryPosted: "072 0077 LM",
    },
    {
      agentCode: "805",
      resultActionEntryDate: "2026-01-16",
      resultActionEntryPosted: "000 0077 LM",
    },
    {
      agentCode: "805",
      resultActionEntryDate: "2026-01-14",
      resultActionEntryPosted: "000 0077 LM",
    },
    {
      agentCode: "805",
      resultActionEntryDate: "2026-01-13",
      resultActionEntryPosted: "000 CS80 LM",
    },
    {
      agentCode: "805",
      resultActionEntryDate: "2026-01-12",
      resultActionEntryPosted: "000 0077 LM",
    },
    {
      agentCode: "515",
      resultActionEntryDate: "2025-05-06",
      resultActionEntryPosted: "164 0077 LM",
    },
    {
      agentCode: "315",
      resultActionEntryDate: "2025-02-26",
      resultActionEntryPosted: "096 0077 LM",
    },
    {
      agentCode: "052",
      resultActionEntryDate: "2024-01-09",
      resultActionEntryPosted: "048 CS80 LM",
    },
  ],
  activated: false,
  addressLine1: "123 Fake St",
  addressLine2: "Suite 106",
  amountDueCents: 0,
  authFlag: "",
  authorizedUser: "Indigo Blue",
  autopayDisabledReason: null,
  bothDataPanel: {
    currentMinPayDueDescription: "string",
    cycleCode: "string",
    dailyPayoffRate: 0,
    lastMPDChangeDate: "string",
    lastStatementMPDDescription: "string",
    lastStatementPricing: "string",
    lastStatementPricingDescription: "string",
    lastStatementPricingTitle: "string",
    lateFeeTitle: "string",
    lateFeeDescription: "string",
    pricingControlCure: "string",
    pricingTierDescription: "string",
    pricingTierTitle: "string",
    pricingStrategySeverityLevel: "<br>",
    renewalPeriod: "string",
    statusCodeChangeDate: "string",
  },
  cardNumber: "2234123412341234",
  city: "Austin",
  collectionsDataPanel: {
    autoReageDate: "string",
    chargeOffAmountCents: 0,
    chargeOffDate: "string",
    delinquentStartDate: "string",
    entryDate: "string",
    fiveCycleDelinquentAmountCents: 0,
    fourCycleDelinquentAmountCents: 0,
    lastReageDate: "string",
    lastTrueReageCode: "string",
    lastTrueWorkoutCode: "string",
    lastWorkoutDate: "string",
    nextWorkDate: "string",
    oneCycleDelinquentAmountCents: 0,
    prevReageDate: "string",
    prevTrueReageCode: "string",
    prevTrueWorkoutCode: "string",
    prevWorkoutDate: "string",
    pricingLockEndDate: "string",
    pricingMinimumPaymentDueAmount: "0.00",
    priorReageDate: "string",
    priorTrueReageCode: "string",
    reageCount: 0,
    sevenCycleDelinquentAmountCents: 0,
    sixCycleDelinquentAmountCents: 0,
    threeCycleDelinquentAmountCents: 0,
    totalAutoReage: 0,
    twoCycleDelinquentAmountCents: 0,
    workoutPlanStartDate: "string",
  },
  creditAvailableCents: 5000,
  creditLimitCents: 50000,
  csrDataPanel: {
    behaviorCreditBureauScore: "string",
    cardType: "string",
    cashAdvanceOut: 0,
    creditLineLastChangeDate: "string",
    creditLinePrevChangeDate: "string",
    creditLineReviewDate: "string",
    expirationDate: "string",
    fdrACHSkip: "string",
    firstUtilizeDate: "string",
    fraudSuspStrategy: "string",
    fraudSuspStrategyDate: "string",
    lastCardOrderedDate: "string",
    lastCashAdvanceAmountCents: 0,
    lastCashAdvanceDate: "string",
    lastCreditLineChange: "string",
    lastLetterMailedDate: "string",
    lastLetterMailedID: "string",
    lastPINChangeDate: "string",
    lostStolenDate: "string",
    marketingInfo: "string",
    months123Delinquent: "string",
    numberOfCards: 0,
    ocl10PercentOrGreater: "string",
    overlimitHistory: 0,
    payAhead: "string",
    pinTries: "string",
    sourceCode: "string",
  },
  currentBalanceCents: 15000,
  currentDwbuid: "unpopulated",
  daysDelinquent: 41,
  debtDisclosure: null,
  delinquentAmountCents: 5000,
  delinquentBucket: "30",
  employeeVipStatus: "No",
  externalStatusCode: "Z",
  forecastMPDHoverData: {
    firstPaymentAmountCents: 40000,
    secondPaymentAmountCents: 30000,
    thirdPaymentAmountCents: 20000,
  },
  forecastMinPayDueHoverDescription:
    "1%x(bal less FFC&MF or 1/12AF)+FFC+MF or 1/12AF OR $41",
  internalStatusCode: "A",
  internalExternalStatus: "Charged Off / ",
  isEnrolledAutopay: true,
  isLocked: true,
  lastContactCode: "12345",
  lastContactDate: "06/23/2022",
  lastStatementBalanceCents: 0,
  minPayDueCents: 1000,
  minPayDueAmount: "$10.00",
  minPayDueAmountHoverDescription: "LS FFC+$15 Ovrd",
  name: "Ebony Black",
  nextCycleDate: "2023-08-23",
  oclAmountCents: 100,
  openDate: "2023-12-01",
  p2d: ["Kelly Green / Mother", "Frank Green / Father"],
  partyId: "3438",
  paymentDueDate: "2023-07-15",
  permanentQueue: "000",
  permanentQueueCode: "778",
  phoneNumber: "1234567890",
  prevDwbuid: "12341234",
  prevDwbuid2: "34234234",
  prevDwbuid3: "12341234",
  registrationDateTime: "09/09/2023",
  scheduledPayments: [
    {
      id: "100",
      amountCents: 2500,
      scheduledPaymentDate: "2023-10-18",
      confirmationId: "100",
      paymentAmount: "custom",
      paymentMethod: { id: "1000", name: "Visa" },
      status: "processing",
    },
    {
      id: "101",
      amountCents: 10000,
      scheduledPaymentDate: "2023-10-19",
      confirmationId: "101",
      paymentAmount: "custom",
      paymentMethod: { id: "1000", name: "Visa" },
      status: "processing",
    },
    {
      id: "102",
      amountCents: 10000,
      scheduledPaymentDate: "2023-10-20",
      confirmationId: "102",
      paymentAmount: "custom",
      paymentMethod: { id: "1000", name: "Visa" },
      status: "processing",
    },
    {
      id: "103",
      amountCents: 10000,
      scheduledPaymentDate: "2023-10-21",
      confirmationId: "103",
      paymentAmount: "custom",
      paymentMethod: { id: "1000", name: "Visa" },
      status: "processing",
    },
  ],
  securityHint: "pass",
  securityWord: "word",
  specialHandlingIndicator: "lorem",
  state: "Texas",
  stateCode: "TX",
  statusReasonCode: "lorem",
  temporaryQueue: "103",
  totalAmountDueCents: 15000,
  transferReason: "05/2016",
  zipcode: "77777",
  lastPaymentDate: "2023-01-01",
  lastStatementDate: "2023-01-01",
  username: "MockUsername123",
};

export const MOCK_PAYMENT_HISTORY: GetPaymentHistoryResponse = [
  {
    cycleDate: "2023-04-08",
    amountDue: 75667,
    amountDelq: 50365,
    delqBucket: "56",
    dueDate: "2022-12-22",
    paymentInfo: [
      {
        amountPaid: 39851,
        postDate: "2023-04-23",
        effectiveDate: "2022-09-30",
        transactionType: "PMT",
      },
      {
        amountPaid: -20539,
        postDate: "2023-07-13",
        effectiveDate: "2023-02-21",
        transactionType: "PMT RVRSL",
      },
      {
        amountPaid: 23818,
        postDate: "2022-12-21",
        effectiveDate: "2022-09-23",
        transactionType: "PMT",
      },
      {
        amountPaid: 83882,
        postDate: "2022-12-15",
        effectiveDate: "2022-12-19",
        transactionType: "PMT",
      },
      {
        amountPaid: 5103,
        postDate: "2023-07-15",
        effectiveDate: "2022-11-10",
        transactionType: "FC Adj",
      },
      {
        amountPaid: -46816,
        postDate: "2023-03-26",
        effectiveDate: "2023-02-01",
        transactionType: "FC Adj",
      },
      {
        amountPaid: 77333,
        postDate: "2023-05-04",
        effectiveDate: "2022-08-23",
        transactionType: "LF Adj",
      },
      {
        amountPaid: -13823,
        postDate: "2023-03-30",
        effectiveDate: "2022-10-19",
        transactionType: "FC Adj",
      },
    ],
  },
  {
    cycleDate: "2023-01-19",
    amountDue: 98262,
    amountDelq: 2302,
    delqBucket: "62",
    dueDate: "2023-02-04",
    paymentInfo: [],
  },
  {
    cycleDate: "2022-12-20",
    amountDue: 81115,
    amountDelq: 1039,
    delqBucket: "69",
    dueDate: "2022-08-29",
    paymentInfo: [
      {
        amountPaid: -6964,
        postDate: "2023-02-19",
        effectiveDate: "2023-04-16",
        transactionType: "PMT",
      },
    ],
  },
  {
    cycleDate: "2022-08-29",
    amountDue: 27352,
    amountDelq: 55577,
    delqBucket: "55",
    dueDate: "2023-03-04",
    paymentInfo: [],
  },
  {
    cycleDate: "2022-09-21",
    amountDue: 8530,
    amountDelq: 60672,
    delqBucket: "31",
    dueDate: "2023-03-17",
    paymentInfo: [
      {
        amountPaid: -98222,
        postDate: "2023-05-16",
        effectiveDate: "2023-06-14",
        transactionType: "LF Adj",
      },
      {
        amountPaid: -20767,
        postDate: "2023-06-03",
        effectiveDate: "2023-02-09",
        transactionType: "LF Adj",
      },
      {
        amountPaid: -11751,
        postDate: "2023-04-22",
        effectiveDate: "2023-07-09",
        transactionType: "PMT RVRSL",
      },
      {
        amountPaid: -88204,
        postDate: "2023-03-08",
        effectiveDate: "2023-05-22",
        transactionType: "LF Adj",
      },
      {
        amountPaid: 4242,
        postDate: "2022-09-18",
        effectiveDate: "2023-03-05",
        transactionType: "PMT RVRSL",
      },
    ],
  },
  {
    cycleDate: "2023-01-05",
    amountDue: 75366,
    amountDelq: 2525,
    delqBucket: "24",
    dueDate: "2022-11-07",
    paymentInfo: [],
  },
  {
    cycleDate: "2023-05-25",
    amountDue: 59539,
    amountDelq: 5221,
    delqBucket: "12",
    dueDate: "2022-08-08",
    paymentInfo: [
      {
        amountPaid: 20673,
        postDate: "2023-01-14",
        effectiveDate: "2022-09-10",
        transactionType: "PMT",
      },
      {
        amountPaid: -5115,
        postDate: "2022-10-06",
        effectiveDate: "2023-06-14",
        transactionType: "PMT",
      },
      {
        amountPaid: 50635,
        postDate: "2022-11-24",
        effectiveDate: "2022-10-18",
        transactionType: "PMT",
      },
    ],
  },
  {
    cycleDate: "2023-03-14",
    amountDue: 59944,
    amountDelq: 29211,
    delqBucket: "25",
    dueDate: "2022-08-26",
    paymentInfo: [
      {
        amountPaid: 74233,
        postDate: "2022-11-06",
        effectiveDate: "2023-05-09",
        transactionType: "PMT RVRSL",
      },
      {
        amountPaid: -64565,
        postDate: "2023-01-07",
        effectiveDate: "2022-12-05",
        transactionType: "LF Adj",
      },
      {
        amountPaid: 29278,
        postDate: "2023-04-01",
        effectiveDate: "2023-02-14",
        transactionType: "FC Adj",
      },
      {
        amountPaid: -89215,
        postDate: "2023-07-22",
        effectiveDate: "2023-01-18",
        transactionType: "FC Adj",
      },
      {
        amountPaid: -55717,
        postDate: "2023-05-20",
        effectiveDate: "2023-07-11",
        transactionType: "PMT RVRSL",
      },
      {
        amountPaid: -53568,
        postDate: "2023-01-26",
        effectiveDate: "2023-01-26",
        transactionType: "LF Adj",
      },
      {
        amountPaid: -76208,
        postDate: "2023-05-22",
        effectiveDate: "2022-09-01",
        transactionType: "PMT",
      },
      {
        amountPaid: 70035,
        postDate: "2023-01-22",
        effectiveDate: "2023-01-01",
        transactionType: "PMT RVRSL",
      },
    ],
  },
  {
    cycleDate: "2022-10-04",
    amountDue: 94518,
    amountDelq: 41494,
    delqBucket: "96",
    dueDate: "2022-12-17",
    paymentInfo: [
      {
        amountPaid: -18318,
        postDate: "2022-10-10",
        effectiveDate: "2023-04-15",
        transactionType: "PMT",
      },
    ],
  },
  {
    cycleDate: "2023-04-20",
    amountDue: 74439,
    amountDelq: 82308,
    delqBucket: "37",
    dueDate: "2023-02-27",
    paymentInfo: [],
  },
  {
    cycleDate: "2023-03-16",
    amountDue: 72138,
    amountDelq: 66919,
    delqBucket: "64",
    dueDate: "2023-02-13",
    paymentInfo: [
      {
        amountPaid: 1976,
        postDate: "2022-10-26",
        effectiveDate: "2022-10-26",
        transactionType: "PMT RVRSL",
      },
      {
        amountPaid: -3009,
        postDate: "2023-05-19",
        effectiveDate: "2022-10-16",
        transactionType: "LF Adj",
      },
    ],
  },
  {
    cycleDate: "2022-11-09",
    amountDue: 75759,
    amountDelq: 4538,
    delqBucket: "65",
    dueDate: "2022-08-15",
    paymentInfo: [
      {
        amountPaid: -44064,
        postDate: "2022-08-26",
        effectiveDate: "2023-06-27",
        transactionType: "LF Adj",
      },
      {
        amountPaid: 5649,
        postDate: "2022-08-11",
        effectiveDate: "2022-11-28",
        transactionType: "FC Adj",
      },
      {
        amountPaid: 68188,
        postDate: "2022-09-04",
        effectiveDate: "2023-01-15",
        transactionType: "FC Adj",
      },
      {
        amountPaid: -2991,
        postDate: "2022-08-14",
        effectiveDate: "2022-12-19",
        transactionType: "LF Adj",
      },
      {
        amountPaid: -53202,
        postDate: "2022-08-06",
        effectiveDate: "2022-12-16",
        transactionType: "PMT RVRSL",
      },
      {
        amountPaid: -66764,
        postDate: "2023-03-11",
        effectiveDate: "2023-04-09",
        transactionType: "PMT",
      },
      {
        amountPaid: 11491,
        postDate: "2022-08-26",
        effectiveDate: "2023-02-08",
        transactionType: "PMT RVRSL",
      },
      {
        amountPaid: 62142,
        postDate: "2022-11-28",
        effectiveDate: "2022-08-30",
        transactionType: "PMT",
      },
      {
        amountPaid: -49123,
        postDate: "2023-08-02",
        effectiveDate: "2023-06-25",
        transactionType: "LF Adj",
      },
    ],
  },
  {
    cycleDate: "2023-04-08",
    amountDue: 75667,
    amountDelq: 50365,
    delqBucket: "56",
    dueDate: "2022-12-22",
    paymentInfo: [
      {
        amountPaid: 39851,
        postDate: "2023-04-23",
        effectiveDate: "2022-09-30",
        transactionType: "PMT",
      },
      {
        amountPaid: -20539,
        postDate: "2023-07-13",
        effectiveDate: "2023-02-21",
        transactionType: "PMT RVRSL",
      },
      {
        amountPaid: 23818,
        postDate: "2022-12-21",
        effectiveDate: "2022-09-23",
        transactionType: "PMT",
      },
      {
        amountPaid: 83882,
        postDate: "2022-12-15",
        effectiveDate: "2022-12-19",
        transactionType: "PMT",
      },
      {
        amountPaid: 5103,
        postDate: "2023-07-15",
        effectiveDate: "2022-11-10",
        transactionType: "FC Adj",
      },
      {
        amountPaid: -46816,
        postDate: "2023-03-26",
        effectiveDate: "2023-02-01",
        transactionType: "FC Adj",
      },
      {
        amountPaid: 77333,
        postDate: "2023-05-04",
        effectiveDate: "2022-08-23",
        transactionType: "LF Adj",
      },
      {
        amountPaid: -13823,
        postDate: "2023-03-30",
        effectiveDate: "2022-10-19",
        transactionType: "FC Adj",
      },
    ],
  },
  {
    cycleDate: "2023-01-19",
    amountDue: 98262,
    amountDelq: 2302,
    delqBucket: "62",
    dueDate: "2023-02-04",
    paymentInfo: [],
  },
  {
    cycleDate: "2022-12-20",
    amountDue: 81115,
    amountDelq: 1039,
    delqBucket: "69",
    dueDate: "2022-08-29",
    paymentInfo: [
      {
        amountPaid: -6964,
        postDate: "2023-02-19",
        effectiveDate: "2023-04-16",
        transactionType: "PMT",
      },
    ],
  },
  {
    cycleDate: "2022-08-29",
    amountDue: 27352,
    amountDelq: 55577,
    delqBucket: "55",
    dueDate: "2023-03-04",
    paymentInfo: [],
  },
  {
    cycleDate: "2022-09-21",
    amountDue: 8530,
    amountDelq: 60672,
    delqBucket: "31",
    dueDate: "2023-03-17",
    paymentInfo: [
      {
        amountPaid: -98222,
        postDate: "2023-05-16",
        effectiveDate: "2023-06-14",
        transactionType: "LF Adj",
      },
      {
        amountPaid: -20767,
        postDate: "2023-06-03",
        effectiveDate: "2023-02-09",
        transactionType: "LF Adj",
      },
      {
        amountPaid: -11751,
        postDate: "2023-04-22",
        effectiveDate: "2023-07-09",
        transactionType: "PMT RVRSL",
      },
      {
        amountPaid: -88204,
        postDate: "2023-03-08",
        effectiveDate: "2023-05-22",
        transactionType: "LF Adj",
      },
      {
        amountPaid: 4242,
        postDate: "2022-09-18",
        effectiveDate: "2023-03-05",
        transactionType: "PMT RVRSL",
      },
    ],
  },
  {
    cycleDate: "2023-01-05",
    amountDue: 75366,
    amountDelq: 2525,
    delqBucket: "24",
    dueDate: "2022-11-07",
    paymentInfo: [],
  },
  {
    cycleDate: "2023-05-25",
    amountDue: 59539,
    amountDelq: 5221,
    delqBucket: "12",
    dueDate: "2022-08-08",
    paymentInfo: [
      {
        amountPaid: 20673,
        postDate: "2023-01-14",
        effectiveDate: "2022-09-10",
        transactionType: "PMT",
      },
      {
        amountPaid: -5115,
        postDate: "2022-10-06",
        effectiveDate: "2023-06-14",
        transactionType: "PMT",
      },
      {
        amountPaid: 50635,
        postDate: "2022-11-24",
        effectiveDate: "2022-10-18",
        transactionType: "PMT",
      },
    ],
  },
  {
    cycleDate: "2023-03-14",
    amountDue: 59944,
    amountDelq: 29211,
    delqBucket: "25",
    dueDate: "2022-08-26",
    paymentInfo: [
      {
        amountPaid: 74233,
        postDate: "2022-11-06",
        effectiveDate: "2023-05-09",
        transactionType: "PMT RVRSL",
      },
      {
        amountPaid: -64565,
        postDate: "2023-01-07",
        effectiveDate: "2022-12-05",
        transactionType: "LF Adj",
      },
      {
        amountPaid: 29278,
        postDate: "2023-04-01",
        effectiveDate: "2023-02-14",
        transactionType: "FC Adj",
      },
      {
        amountPaid: -89215,
        postDate: "2023-07-22",
        effectiveDate: "2023-01-18",
        transactionType: "FC Adj",
      },
      {
        amountPaid: -55717,
        postDate: "2023-05-20",
        effectiveDate: "2023-07-11",
        transactionType: "PMT RVRSL",
      },
      {
        amountPaid: -53568,
        postDate: "2023-01-26",
        effectiveDate: "2023-01-26",
        transactionType: "LF Adj",
      },
      {
        amountPaid: -76208,
        postDate: "2023-05-22",
        effectiveDate: "2022-09-01",
        transactionType: "PMT",
      },
      {
        amountPaid: 70035,
        postDate: "2023-01-22",
        effectiveDate: "2023-01-01",
        transactionType: "PMT RVRSL",
      },
    ],
  },
  {
    cycleDate: "2022-10-04",
    amountDue: 94518,
    amountDelq: 41494,
    delqBucket: "96",
    dueDate: "2022-12-17",
    paymentInfo: [
      {
        amountPaid: -18318,
        postDate: "2022-10-10",
        effectiveDate: "2023-04-15",
        transactionType: "PMT",
      },
    ],
  },
  {
    cycleDate: "2023-04-20",
    amountDue: 74439,
    amountDelq: 82308,
    delqBucket: "37",
    dueDate: "2023-02-27",
    paymentInfo: [],
  },
  {
    cycleDate: "2023-03-16",
    amountDue: 72138,
    amountDelq: 66919,
    delqBucket: "64",
    dueDate: "2023-02-13",
    paymentInfo: [
      {
        amountPaid: 1976,
        postDate: "2022-10-26",
        effectiveDate: "2022-10-26",
        transactionType: "PMT RVRSL",
      },
      {
        amountPaid: -3009,
        postDate: "2023-05-19",
        effectiveDate: "2022-10-16",
        transactionType: "LF Adj",
      },
    ],
  },
  {
    cycleDate: "2022-11-09",
    amountDue: 75759,
    amountDelq: 4538,
    delqBucket: "65",
    dueDate: "2022-08-15",
    paymentInfo: [
      {
        amountPaid: -44064,
        postDate: "2022-08-26",
        effectiveDate: "2023-06-27",
        transactionType: "LF Adj",
      },
      {
        amountPaid: 5649,
        postDate: "2022-08-11",
        effectiveDate: "2022-11-28",
        transactionType: "FC Adj",
      },
      {
        amountPaid: 68188,
        postDate: "2022-09-04",
        effectiveDate: "2023-01-15",
        transactionType: "FC Adj",
      },
      {
        amountPaid: -2991,
        postDate: "2022-08-14",
        effectiveDate: "2022-12-19",
        transactionType: "LF Adj",
      },
      {
        amountPaid: -53202,
        postDate: "2022-08-06",
        effectiveDate: "2022-12-16",
        transactionType: "PMT RVRSL",
      },
      {
        amountPaid: -66764,
        postDate: "2023-03-11",
        effectiveDate: "2023-04-09",
        transactionType: "PMT",
      },
      {
        amountPaid: 11491,
        postDate: "2022-08-26",
        effectiveDate: "2023-02-08",
        transactionType: "PMT RVRSL",
      },
      {
        amountPaid: 62142,
        postDate: "2022-11-28",
        effectiveDate: "2022-08-30",
        transactionType: "PMT",
      },
      {
        amountPaid: -49123,
        postDate: "2023-08-02",
        effectiveDate: "2023-06-25",
        transactionType: "LF Adj",
      },
    ],
  },
];
export const MOCK_PAYMENT_HISTORY_SHORT: GetPaymentHistoryResponse = [
  {
    cycleDate: "2023-04-08",
    amountDue: 756.67,
    amountDelq: 503.65,
    delqBucket: "56",
    dueDate: "2022-12-22",
    paymentInfo: [
      {
        amountPaid: 398.51,
        postDate: "2023-04-23",
        effectiveDate: "2022-09-30",
        transactionType: "PMT",
      },
      {
        amountPaid: -205.39,
        postDate: "2023-07-13",
        effectiveDate: "2023-02-21",
        transactionType: "PMT RVRSL",
      },
      {
        amountPaid: 238.18,
        postDate: "2022-12-21",
        effectiveDate: "2022-09-23",
        transactionType: "PMT",
      },
      {
        amountPaid: 838.82,
        postDate: "2022-12-15",
        effectiveDate: "2022-12-19",
        transactionType: "PMT",
      },
      {
        amountPaid: 510.3,
        postDate: "2023-07-15",
        effectiveDate: "2022-11-10",
        transactionType: "FC Adj",
      },
      {
        amountPaid: -468.16,
        postDate: "2023-03-26",
        effectiveDate: "2023-02-01",
        transactionType: "FC Adj",
      },
      {
        amountPaid: 773.33,
        postDate: "2023-05-04",
        effectiveDate: "2022-08-23",
        transactionType: "LF Adj",
      },
      {
        amountPaid: -138.23,
        postDate: "2023-03-30",
        effectiveDate: "2022-10-19",
        transactionType: "FC Adj",
      },
    ],
  },
  {
    cycleDate: "2023-01-19",
    amountDue: 982.62,
    amountDelq: 230.2,
    delqBucket: "62",
    dueDate: "2023-02-04",
    paymentInfo: [],
  },
  {
    cycleDate: "2022-12-20",
    amountDue: 811.15,
    amountDelq: 103.9,
    delqBucket: "69",
    dueDate: "2022-08-29",
    paymentInfo: [
      {
        amountPaid: -696.4,
        postDate: "2023-02-19",
        effectiveDate: "2023-04-16",
        transactionType: "PMT",
      },
    ],
  },
  {
    cycleDate: "2022-08-29",
    amountDue: 273.52,
    amountDelq: 555.77,
    delqBucket: "55",
    dueDate: "2023-03-04",
    paymentInfo: [],
  },
  {
    cycleDate: "2022-09-21",
    amountDue: 853.0,
    amountDelq: 606.72,
    delqBucket: "31",
    dueDate: "2023-03-17",
    paymentInfo: [
      {
        amountPaid: -982.22,
        postDate: "2023-05-16",
        effectiveDate: "2023-06-14",
        transactionType: "LF Adj",
      },
      {
        amountPaid: -207.67,
        postDate: "2023-06-03",
        effectiveDate: "2023-02-09",
        transactionType: "LF Adj",
      },
      {
        amountPaid: -117.51,
        postDate: "2023-04-22",
        effectiveDate: "2023-07-09",
        transactionType: "PMT RVRSL",
      },
      {
        amountPaid: -882.04,
        postDate: "2023-03-08",
        effectiveDate: "2023-05-22",
        transactionType: "LF Adj",
      },
      {
        amountPaid: 42.42,
        postDate: "2022-09-18",
        effectiveDate: "2023-03-05",
        transactionType: "PMT RVRSL",
      },
    ],
  },
  {
    cycleDate: "2023-01-05",
    amountDue: 753.66,
    amountDelq: 25.25,
    delqBucket: "24",
    dueDate: "2022-11-07",
    paymentInfo: [],
  },
];

export const MOCK_AUTOPAY_ENROLLMENT: GetAutopayEnrollmentResponse = {
  enrollmentType: EnrollmentType.Eligible,
  enrollmentInfo: {
    abaNumber: "111000025",
    ddaNumber: "1234567890",
    bankName: "Wells Fargo Bank",
    ownerName: "John Doe",
    amount: "Fixed Payment Amount: $50.00",
    party: "ACCOUNT_OWNER",
  },
  enrolledDate: "2024-10-30",
  reEnrollDate: "2023-01-01",
  isAutopaySkipped: false,
  cancelSkipAutopayDisabledReason: null,
  isEnrolledAutopay: false,
};

export const MOCK_AUTOPAY_ENROLLMENT_INELIGIBLE: GetAutopayEnrollmentResponse =
  {
    enrollmentType: EnrollmentType.Ineligible,
    lastEnrollmentDate: "11/05/2022",
    autopayDisabledReason: "Cannot Enroll in Autopay until 05/04/2023",
  };

// Only used for mocking
const MOCK_MAIL_TYPES: SecureMailConversationType[] = [
  "NEW",
  "OPEN",
  "READONLY",
  "CMEXPIRE",
];

export const MOCK_SECURE_MAIL_LIST: GetSecureMailListResponse = {
  total: 430,
  secureMail: [...Array(100).keys()].map((_, index) => {
    const typeOptions = MOCK_MAIL_TYPES;
    const minDate = new Date(2022, 0, 1).getTime();
    const maxDate = new Date(2024 + 1, 0, 1).getTime();

    return {
      // pad w 0's till 7 digits
      dwbuid: Math.round(Math.random() * 100000).toString(),
      subject: `Subject Line ${index}`,
      // randomly generate a date between 2022 and 2024
      updateDate: new Date(Math.random() * (maxDate - 1 - minDate) + minDate),
      // randomly select a type
      type: typeOptions[Math.floor(Math.random() * typeOptions.length)],
      secureMailId: index === 0 ? "abcdef-123456" : nanoid(),
    };
  }),
};

export const MOCK_SECUREMAIL = {
  secureMailId: "test-secure-mail-id",
  classificationId: "testId-secureId",
};

export const MOCK_CLASSIFICATIONS: GetClassificationsResponse = {
  classifications: [
    {
      id: "0",
      description: "Unclassified",
    },
    {
      id: "1",
      description: "CSR: Web-Related",
    },
    {
      id: "2",
      description: "CSR: Credit Line Increase Request",
    },
    {
      id: "3",
      description: "CSR: Card",
    },
  ],
};

export const MOCK_CLASSIFICATION_COUNT: GetClassificationCountResponse = {
  classifications: [
    {
      id: "0",
      description: "Unclassified",
      count: 6,
    },
    {
      id: "1",
      description: "CSR: Web-Related",
      count: 10,
    },
    {
      id: "2",
      description: "CSR: Credit Line Increase Request",
      count: 7,
    },
    {
      id: "3",
      description: "CSR: Card",
      count: 4,
    },
    {
      id: "4",
      description: "Classification 5",
      count: 4,
    },
    {
      id: "5",
      description: "Classification 6",
      count: 4,
    },
    {
      id: "6",
      description: "Classification 7",
      count: 4,
    },
    {
      id: "7",
      description: "Classification 8",
      count: 4,
    },
    {
      id: "8",
      description: "Classification 9",
      count: 4,
    },
    {
      id: "9",
      description: "Classification 10",
      count: 4,
    },
    {
      id: "10",
      description: "Classification",
      count: 4,
    },
  ],
};

export const MOCK_SECURE_MAIL_THREAD: GetSecureMailThreadResponse = {
  id: "abcdef-123456",
  dwbuid: "123456",
  firstName: "Ebony",
  lastName: "Black",
  subject: "Increasing Credit Line",
  type: "OPEN",
  classificationId: "2",
  messages: [
    {
      messageId: "1",
      sender: "John Doe",
      body: "I’ve made timely payments for the last 6 months and hope my responsible card usage supports my case for an increase.",
      createDate: new Date("2022-08-14T02:41:00.000Z"),
      dwbuid: "123456",
      employeeId: null,
      employeeFirstName: null,
      employeeLastName: null,
      actionId: "0",
      attachments: [],
      timeRead: null,
    },
    {
      messageId: "2",
      sender: "1FB",
      body: "Thank you for your credit line increase inquiry. We are reviewing your account and will have a response for you soon.",
      createDate: new Date("2022-08-14T03:41:00.000Z"),
      dwbuid: "123456",
      employeeId: "1111111111",
      employeeFirstName: "Sammy",
      employeeLastName: "Employee",
      actionId: "0",
      attachments: [],
      timeRead: new Date("2022-08-14T04:41:00.000Z"),
    },
    {
      messageId: "3",
      sender: "1FB",
      body: "Hi I'm Johnny! I will be helping you with your credit line increase inquiry. I see your payments for the last 6 months, looks like there was one missed payment!",
      createDate: new Date("2022-08-14T03:41:00.000Z"),
      dwbuid: "123456",
      employeeId: "2222222222",
      employeeFirstName: "Johnny",
      employeeLastName: "Employee",
      actionId: "0",
      attachments: [
        {
          id: "1",
          name: "john_doe_payments_2022.pdf",
          mimeType: "application/pdf",
        },
      ],
      timeRead: new Date("2022-08-14T04:41:00.000Z"),
    },
    {
      messageId: "4",
      sender: "John Doe",
      body: "That looks right for the most part. For the missed payment, I had set up automatic pay from my Chase bank account but my bank card was declined. I talked to Chase and apparently, it was a mistake on their part. I've attached some screen shots here as reference.",
      createDate: new Date("2022-08-14T03:41:00.000Z"),
      dwbuid: "123456",
      employeeId: null,
      employeeFirstName: null,
      employeeLastName: null,
      actionId: "0",
      attachments: [
        {
          id: "2",
          name: "screenshot_1.jpg",
          mimeType: "image/jpeg",
        },
        {
          id: "3",
          name: "screenshot_2.jpg",
          mimeType: "image/jpeg",
        },
      ],
      timeRead: null,
    },
  ],
  employees: [
    {
      employeeId: "1",
      firstname: "Sammy",
      lastname: "Employee",
    },
    {
      employeeId: "2",
      firstname: "Johnny",
      lastname: "Employee",
    },
  ],
};

export const MOCK_CARDMEMBER_MAIL_LIST: GetCardmemberMailListResponse = {
  total: 5,
  secureMail: [
    {
      subject: `A Forgot password`,
      updateDate: new Date(),
      type: "OPEN",
      secureMailId: "be921666-98c2-422e-af05-b53c116312c",
    },
    {
      subject: `B Login issues`,
      updateDate: new Date(),
      type: "NEW",
      secureMailId: "f164ca82-cfde-45b1-8c63-61b6e9b261a2",
    },
    {
      subject: `C Update card information`,
      updateDate: new Date(),
      type: "OPEN",
      secureMailId: "10c38deb-2096-42ac-8874-587d5a64f7e0",
    },
    {
      subject: `D Update card information`,
      updateDate: new Date(),
      type: "OPEN",
      secureMailId: "c05070c0-570f-409b-a629-3dedd1d5cc90",
    },
    {
      subject: `E Update card information`,
      updateDate: new Date(),
      type: "NEW",
      secureMailId: "2266964d-17e6-49d7-b8e1-4a4567e8fb3a",
    },
  ],
};

export const MOCK_PAYMENT_METHODS: GetPaymentMethodsResponse = {
  cardMemberAccounts: [
    {
      id: "cm_account_100",
      type: "credit_card",
      isDefault: true,
      isInactive: false,
      hasRestrictions: false,
      is1FBAccount: true,
      brand: "mc",
      last4: "1234",
      lastUsedDate: "09/11/2023",
      cardHolderFirstName: "Wilson",
      cardHolderLastName: "McWilson",
      isExpired: false,
      cardNumber: "123",
      expirationDate: "12/22",
      ownerType: "ACCOUNT_OWNER",
      restrictions: [],
      addressLine1: "123 Somewhere Ln",
      addressLine2: "",
      city: "Austin",
      stateCode: "TX",
      zipcode: "77777",
      phoneNumber: "1234567890",
    },
    {
      id: "expired_test_cm",
      type: "credit_card",
      isDefault: false,
      isInactive: false,
      hasRestrictions: false,
      is1FBAccount: true,
      brand: "mc",
      last4: "1234",
      lastUsedDate: "09/11/2023",
      cardHolderFirstName: "Wilson",
      cardHolderLastName: "McWilson",
      isExpired: true,
      cardNumber: "1234",
      expirationDate: "12/22",
      ownerType: "ACCOUNT_OWNER",
      restrictions: [],
      addressLine1: "123 Somewhere Ln",
      addressLine2: "",
      city: "Austin",
      stateCode: "TX",
      zipcode: "77777",
      phoneNumber: "1234567890",
    },
    {
      id: "cm_account_101",
      type: "credit_card",
      isDefault: false,
      isInactive: false,
      hasRestrictions: false,
      is1FBAccount: true,
      brand: "visa",
      last4: "1235",
      lastUsedDate: "09/12/2023",
      cardHolderFirstName: "Wilson",
      cardHolderLastName: "McWilson",
      isExpired: false,
      cardNumber: "1235",
      expirationDate: "12/22",
      ownerType: "ACCOUNT_OWNER",
      restrictions: [],
      addressLine1: "123 Somewhere Ln",
      addressLine2: "",
      city: "Austin",
      stateCode: "TX",
      zipcode: "77777",
      phoneNumber: "1234567890",
    },
    {
      id: "cm_account_102",
      type: "credit_card",
      isDefault: false,
      isInactive: false,
      hasRestrictions: false,
      is1FBAccount: false,
      brand: "visa",
      last4: "1236",
      lastUsedDate: "09/13/2023",
      cardHolderFirstName: "Wilson",
      cardHolderLastName: "McWilson",
      isExpired: false,
      cardNumber: "1236",
      expirationDate: "12/22",
      ownerType: "AUTHORIZED_USER",
      restrictions: [],
      addressLine1: "123 Somewhere Ln",
      addressLine2: "",
      city: "Austin",
      stateCode: "TX",
      zipcode: "77777",
      phoneNumber: "1234567890",
    },
    {
      id: "cm_account_103",
      type: "credit_card",
      isDefault: false,
      isInactive: false,
      hasRestrictions: false,
      is1FBAccount: false,
      brand: "visa",
      last4: "1237",
      lastUsedDate: "09/14/2023",
      cardHolderFirstName: "Wilson",
      cardHolderLastName: "McWilson",
      isExpired: false,
      cardNumber: "1237",
      expirationDate: "12/22",
      ownerType: "AUTHORIZED_USER",
      restrictions: [],
      addressLine1: "123 Somewhere Ln",
      addressLine2: "",
      city: "Austin",
      stateCode: "TX",
      zipcode: "77777",
      phoneNumber: "1234567890",
    },
    {
      id: "cm_account_104",
      type: "checking_account",
      isDefault: false,
      isInactive: false,
      hasRestrictions: false,
      is1FBAccount: true,
      brand: null,
      last4: "1324",
      lastUsedDate: "09/15/2023",
      cardHolderFirstName: "Wilson",
      cardHolderLastName: "McWilson",
      isExpired: false,
      abaNumber: "123456789",
      accountNumber: "12345",
      bankName: "1fb",
      ownerType: "AUTHORIZED_USER",
      restrictions: [],
      addressLine1: "123 Somewhere Ln",
      addressLine2: "",
      city: "Austin",
      stateCode: "TX",
      zipcode: "77777",
      phoneNumber: "1234567890",
    },
  ],
  thirdPartyAccounts: [
    {
      id: "3rd_party_100",
      type: "credit_card",
      isDefault: true,
      isInactive: false,
      hasRestrictions: false,
      is1FBAccount: true,
      brand: "mc",
      last4: "1238",
      lastUsedDate: "09/11/2023",
      cardHolderFirstName: "Wilson",
      cardHolderLastName: "McWilson",
      isExpired: false,
      cardNumber: "1238",
      expirationDate: "12/22",
      ownerType: "THIRD_PARTY",
      restrictions: [],
      addressLine1: "123 Somewhere Ln",
      addressLine2: "",
      city: "Austin",
      stateCode: "TX",
      zipcode: "77777",
      phoneNumber: "1234567890",
    },
    {
      id: "expired_test_3rdparty",
      type: "credit_card",
      isDefault: false,
      isInactive: false,
      hasRestrictions: false,
      is1FBAccount: true,
      brand: "mc",
      last4: "1239",
      lastUsedDate: "09/11/2023",
      cardHolderFirstName: "Wilson",
      cardHolderLastName: "McWilson",
      isExpired: true,
      cardNumber: "1239",
      expirationDate: "12/22",
      ownerType: "THIRD_PARTY",
      restrictions: [],
      addressLine1: "123 Somewhere Ln",
      addressLine2: "",
      city: "Austin",
      stateCode: "TX",
      zipcode: "77777",
      phoneNumber: "1234567890",
    },
    {
      id: "3rd_party_101",
      type: "credit_card",
      isDefault: false,
      isInactive: false,
      hasRestrictions: false,
      is1FBAccount: true,
      brand: "visa",
      last4: "1230",
      lastUsedDate: "09/12/2023",
      cardHolderFirstName: "Wilson",
      cardHolderLastName: "McWilson",
      isExpired: false,
      cardNumber: "1230",
      expirationDate: "12/22",
      ownerType: "THIRD_PARTY",
      restrictions: [],
      addressLine1: "123 Somewhere Ln",
      addressLine2: "",
      city: "Austin",
      stateCode: "TX",
      zipcode: "77777",
      phoneNumber: "1234567890",
    },
  ],
};

export const MOCK_PAYMENT_TRANSACTIONS: GetPaymentTransactionsResponse = {
  numberOfPendingPayments: 4,
  pendingPaymentsAmountCents: 14700,
  paymentTransactions: [
    {
      id: "0",
      status: "pending",
      type: "B2C",
      processingStatusType: "ACH",
      effectiveDate: "2023-11-11",
      destination: "x4906",
      source: "x0968",
      amountCents: 1500,
      confirmationId: "paymentId0",
      creationDateStr: "09/12/23 08:09:47 AM",
      agent: "BKN",
      paymentMethod: {
        id: "something_random",
        type: "credit_card",
        isDefault: true,
        isInactive: false,
        hasRestrictions: false,
        is1FBAccount: true,
        brand: "mc",
        last4: "1234",
        lastUsedDate: "2023/11/11",
        cardHolderFirstName: "Removed",
        cardHolderLastName: "Account",
        isExpired: false,
        cardNumber: "123",
        expirationDate: "12/22",
        ownerType: "ACCOUNT_OWNER",
        restrictions: [],
        addressLine1: "123 Somewhere Ln",
        addressLine2: "",
        city: "Austin",
        stateCode: "TX",
        zipcode: "77777",
        phoneNumber: "1234567890",
      },
    },
    {
      id: "1",
      status: "pending",
      type: "B2C",
      processingStatusType: "ACH",
      effectiveDate: "2023-08-30",
      destination: "x4906",
      source: "x0968",
      amountCents: 14788,
      confirmationId: "paymentId1",
      creationDateStr: "08/12/23 08:09:47 AM",
      agent: "MA",
      paymentMethod: MOCK_PAYMENT_METHODS.thirdPartyAccounts[0],
    },
    {
      id: "3",
      status: "pending",
      type: "B2C",
      processingStatusType: "ACH",
      effectiveDate: "2023-11-11",
      destination: "x4906",
      source: "x0968",
      amountCents: 14788,
      confirmationId: "paymentId2",
      creationDateStr: "08/12/23 08:09:47 AM",
      agent: "MA",
      paymentMethod: MOCK_PAYMENT_METHODS.cardMemberAccounts[0],
      seriesId: "include",
    },
    {
      id: "4",
      status: "pending",
      type: "B2C",
      processingStatusType: "PAPER",
      effectiveDate: "2023-11-30",
      destination: "x4906",
      source: "x0968",
      amountCents: 14788,
      confirmationId: "paymentId3",
      creationDateStr: "08/12/23 08:09:47 AM",
      agent: "MA",
      paymentMethod: MOCK_PAYMENT_METHODS.cardMemberAccounts[0],
      seriesId: "include",
    },
    {
      id: "somethingunique34634",
      status: "pending",
      type: "B2C",
      processingStatusType: "PAPER",
      effectiveDate: "2023-12-05",
      destination: "x4906",
      source: "x0968",
      amountCents: 14788,
      confirmationId: "paymentId4",
      creationDateStr: "08/12/23 08:09:47 AM",
      agent: "MA",
      paymentMethod: MOCK_PAYMENT_METHODS.cardMemberAccounts[0],
      seriesId: "include",
    },
    {
      id: "5",
      status: "pending",
      type: "B2C",
      processingStatusType: "ACH",
      effectiveDate: "2023-11-30",
      destination: "x4906",
      source: "x0968",
      amountCents: 14788,
      confirmationId: "paymentId5",
      creationDateStr: "08/12/23 08:09:47 AM",
      agent: "MA",
      paymentMethod: MOCK_PAYMENT_METHODS.thirdPartyAccounts[0],
      seriesId: "don't include",
    },
    {
      id: "6",
      status: "processed",
      type: "C2C",
      processingStatusType: "ACH",
      effectiveDate: "2023-04-30",
      destination: "x4906",
      source: "x0968",
      amountCents: 2000,
      confirmationId: "24542443",
      creationDateStr: "04/12/23 08:09:47 AM",
      agent: "RZK",
      paymentMethod: MOCK_PAYMENT_METHODS.cardMemberAccounts[0],
    },
    {
      id: "7",
      status: "processed",
      type: "B2C",
      processingStatusType: "ACH",
      effectiveDate: "2023-03-30",
      destination: "x4906",
      source: "x0968",
      amountCents: 3400,
      confirmationId: "paymentId6",
      creationDateStr: "03/12/23 08:09:47 AM",
      agent: "381",
      paymentMethod: MOCK_PAYMENT_METHODS.cardMemberAccounts[0],
    },
    {
      id: "8",
      status: "processed",
      type: "C2C",
      processingStatusType: "ACH",
      effectiveDate: "2023-01-30",
      destination: "x4906",
      source: "x0968",
      amountCents: 4500,
      confirmationId: "paymentId7",
      creationDateStr: "01/12/23 08:09:47 AM",
      agent: "BKN",
      paymentMethod: MOCK_PAYMENT_METHODS.cardMemberAccounts[0],
    },
  ],
  statusFilters: [
    { label: "Pending", value: "pending" },
    { label: "Processed", value: "processed" },
  ],
  typeFilters: [
    { label: "B2C", value: "B2C" },
    { label: "C2C", value: "C2C" },
  ],
  destinationFilters: [
    { label: "x4906", value: "x4906" },
    { label: "x0968", value: "x0968" },
  ],
  sourceFilters: [
    { label: "x4906", value: "x4906" },
    { label: "x0968", value: "x0968" },
  ],
};

export const MOCK_PAYMENT_SERIES_SCHEDULE_RESPONSE: GetPaymentSeriesScheduleResponse =
  {
    schedule: [
      {
        date: "2023-10-15",
        amountCents: 100,
      },
      {
        date: "2023-11-15",
        amountCents: 100,
      },
      {
        date: "2023-12-15",
        amountCents: 100,
      },
      {
        date: "2024-01-15",
        amountCents: 100,
      },
      {
        date: "2024-02-15",
        amountCents: 100,
      },
    ],
  };

export const MOCK_PARTY_RESTRICTIONS: GetPartyRestrictionsResponse = {
  cardRestrictions: [
    {
      label: "None",
      value: "NONE",
    },
    {
      label: "Chargeback Unauthorized/Fraud",
      value: "CHARGEBACK_UNAUTHORIZED_FRAUD",
    },
    {
      label: "Chargeback Unrecognized",
      value: "CHARGEBACK_UNRECOGNIZED",
    },
    {
      label: "Possible Fraud",
      value: "POSSIBLE_FRAUD",
    },
  ],
  bankRestrictions: [
    {
      label: "None",
      value: "NONE",
    },
    {
      label: "Account Closed",
      value: "ACCOUNT_CLOSED",
    },
    {
      label: "Acct Frozen",
      value: "ACCOUNT_FROZEN",
    },
    {
      label: "Do Not Rsbmt",
      value: "DO_NOT_RESUBMIT",
    },
  ],
  partyCardRestriction: [
    { restriction: "CHARGEBACK_UNRECOGNIZED" },
    { restriction: "POSSIBLE_FRAUD" },
  ],
  partyBankRestriction: [],
};

export const MOCK_PAYMENT_OVERRIDES_RESPONSE: PaymentOverridesResponse = {
  overrideMessages: [
    {
      overrideInfo: "Mock Payment First Override",
      overrideKey: "overrideMock1",
    },
    {
      overrideInfo: "Mock Payment Second Override",
      overrideKey: "overrideMock2",
    },
  ],
};

export const MOCK_PAYMENT_SCRIPTS_RESPONSE: PaymentScriptsResponse = {
  type: "script",
  message: `'Lorem ipsum dolor sit amet' is a legal phrase indicating a hypothetical or placeholder text used in the drafting of legal documents. It is not a part of this legal agreement, and no party shall be held liable for any damages or losses, whether direct or indirect, arising from any breach of this agreement. Furthermore, neither party shall have any obligation or liability to the other party, except as specifically outlined in this agreement.

  In witness whereof, this agreement shall be governed by and construed in accordance with the laws of the state of [State], without regard to its conflict of laws principles. This agreement may not be amended, modified, or otherwise altered except in writing, signed by both parties. Any waiver of a breach or violation of any provision herein shall not constitute a waiver of any other or subsequent breach or violation.
  
  This agreement contains the entire understanding of the parties with respect to the subject matter hereof and supersedes all prior and contemporaneous agreements and understandings, whether oral or written. No term or condition of this agreement may be changed, waived, discharged, or terminated orally, and no waiver or consent shall be valid unless in writing and signed by the party against whom such waiver or consent is asserted. This agreement shall be binding upon and inure to the benefit of the parties hereto and their respective successors and assigns.`,
};

export const MOCK_BANK_NAMES: GetBankNamesResponse = {
  bankNames: ["1fb", "Wells Fargo", "Chase", "Ally"],
};

const mockRelationSister = {
  id: "196fe714-27a4-421b-a3a5-91fe8f9d2863",
  relationship: "Sister",
};
const mockRelationFriend = {
  id: "e3f0f762-f571-47e6-8f5c-294799bdf792",
  relationship: "Friend",
};
const mockRelationBrother = {
  id: "60eae8a8-3dff-4bda-9950-21194ea16c7f",
  relationship: "Brother",
};
const mockRelationEmployer = {
  id: "cbfc0a0c-4003-4c57-ad15-7c5020201cf6",
  relationship: "Employer",
};
export const MOCK_PERMISSION_TO_DISCUSS_RESPONSE: GetPermissionToDiscussResponse =
  {
    lastVerifiedDate: "2023-06-15",
    permissionsList: [
      {
        id: "pCMUV7t-im",
        agent: "MGM",
        channel: "RES",
        date: "2024-02-15T13:29:00.000",
        effectiveDate: "2024-02-15T00:00:00",
        firstName: "Jessica",
        lastName: "Smith",
        relation: mockRelationSister,
        source: "Affinity",
        status: "active",
      },
      {
        id: "wKK9DdaEn_",
        agent: "MGM",
        channel: "RES",
        date: "2024-02-15T13:28:59.000",
        effectiveDate: "2024-02-15T00:00:00",
        firstName: "Jessica",
        lastName: "Smith",
        relation: mockRelationSister,
        source: "Affinity",
        status: "active",
      },
      {
        id: "lG0xCDzvT6",
        agent: "MGM",
        channel: "RES",
        date: "2024-02-15T13:25:00.000",
        effectiveDate: "2024-02-15T00:00:00",
        firstName: "Jessica",
        lastName: "Smith",
        relation: mockRelationSister,
        source: "Affinity",
        status: "inactive",
      },
      {
        id: "82lAyMToaL",
        agent: "MGM",
        channel: "RES",
        date: "2024-02-15T13:20:00.000",
        effectiveDate: "2024-02-15T00:00:00",
        firstName: "Winston",
        lastName: "Bishop",
        relation: mockRelationFriend,
        source: "Affinity",
        status: "active",
      },
      {
        id: "gDyLRX_yyG",
        agent: "MGM",
        channel: "RES",
        date: "2024-02-15T13:12:00.000",
        effectiveDate: "2024-02-15T00:00:00",
        firstName: "Nicholas",
        lastName: "Miller",
        relation: mockRelationFriend,
        source: "Affinity",
        status: "inactive",
      },
      {
        id: "ChEZb-Zp-Y",
        agent: "MGM",
        channel: "RES",
        date: "2024-02-15T13:03:00.000",
        effectiveDate: "2024-02-15T00:00:00",
        firstName: "Anthony",
        lastName: "Jones",
        relation: mockRelationFriend,
        source: "Affinity",
        status: "active",
      },
      {
        id: "vmlZ-nF6f5",
        agent: "MGM",
        channel: "RES",
        date: "2024-02-15T13:02:00.000",
        effectiveDate: "2024-02-15T00:00:00",
        firstName: "Sam",
        lastName: "Smith",
        relation: mockRelationBrother,
        source: "Affinity",
        status: "active",
      },
      {
        id: "0sGiBiue8R",
        agent: "MGM",
        channel: "RES",
        date: "2024-02-15T13:01:59.000",
        effectiveDate: "2024-02-15T00:00:00",
        firstName: "Sam",
        lastName: "Smith",
        relation: mockRelationBrother,
        source: "Affinity",
        status: "active",
      },
      {
        id: "Qy87S9vU9B",
        agent: "MGM",
        channel: "RES",
        date: "2024-02-15T13:01:00.000",
        effectiveDate: "2024-02-15T00:00:00",
        firstName: "James",
        lastName: "Black",
        relation: mockRelationEmployer,
        source: "Clarity",
        status: "active",
      },

      {
        id: "IBzCfMR1fK",
        agent: "MGM",
        channel: "RES",
        date: "2024-02-10T13:01:00.000",
        effectiveDate: "2024-02-15T00:00:00",
        firstName: "Bob",
        lastName: "Bobbers",
        relation: mockRelationFriend,
        source: "Affinity",
        status: "active",
      },
    ],
    relationshipTypes: [
      mockRelationEmployer,
      mockRelationBrother,
      mockRelationSister,
      mockRelationFriend,
    ],
  };

export const MOCK_PERMISSION_TO_DISCUSS_PARTIAL_RESPONSE: GetPermissionToDiscussResponse =
  {
    lastVerifiedDate: "2023-06-15",
    permissionsList: [
      {
        id: "i8Otk_wf1P",
        agent: "MGM",
        channel: "RES",
        date: "2024-02-15T13:29:00.000",
        effectiveDate: "2024-02-15T00:00:00",
        firstName: "Jessica",
        lastName: "Smith",
        relation: mockRelationSister,
        source: "Affinity",
        status: "active",
      },
      {
        id: "lqzRRSwc2D",
        agent: "MGM",
        channel: "RES",
        date: "2024-02-15T13:20:00.000",
        effectiveDate: "2024-02-15T00:00:00",
        firstName: "Winston",
        lastName: "Bishop",
        relation: mockRelationFriend,
        source: "Affinity",
        status: "active",
      },
      {
        id: "pCMUV7t-im",
        agent: "MGM",
        channel: "RES",
        date: "2024-02-15T13:12:00.000",
        effectiveDate: "2024-02-15T00:00:00",
        firstName: "Nicholas",
        lastName: "Miller",
        relation: mockRelationFriend,
        source: "Affinity",
        status: "inactive",
      },
      {
        id: "fJbp82hrVJ",
        agent: "MGM",
        channel: "RES",
        date: "2024-02-15T13:03:00.000",
        effectiveDate: "2024-02-15T00:00:00",
        firstName: "Anthony",
        lastName: "Jones",
        relation: mockRelationFriend,
        source: "Affinity",
        status: "active",
      },
      {
        id: "5LrRlRBtM5",
        agent: "MGM",
        channel: "RES",
        date: "2024-02-15T13:02:00.000",
        effectiveDate: "2024-02-15T00:00:00",
        firstName: "Sam",
        lastName: "Smith",
        relation: mockRelationBrother,
        source: "Affinity",
        status: "active",
      },
      {
        id: "CPYoPnAFz4",
        agent: "MGM",
        channel: "RES",
        date: "2024-02-15T13:01:00.000",
        effectiveDate: "2024-02-15T00:00:00",
        firstName: "James",
        lastName: "Black",
        relation: mockRelationEmployer,
        source: "Clarity",
        status: "active",
      },

      {
        id: "9y8e5hY5Ag",
        agent: "MGM",
        channel: "RES",
        date: "2024-02-10T13:01:00.000",
        effectiveDate: "2024-02-15T00:00:00",
        firstName: "Bob",
        lastName: "Bobbers",
        relation: mockRelationFriend,
        source: "Affinity",
        status: "active",
      },
    ],
    relationshipTypes: [
      mockRelationEmployer,
      mockRelationBrother,
      mockRelationSister,
      mockRelationFriend,
    ],
  };

export const MOCK_CYCLE_TO_DATE_TRANSACTIONS_RESPONSE: GetCycleToDateTransactionsResponse =
  {
    availableCreditCents: 11013,
    creditLimitCents: 80000,
    currentBalanceCents: 78327,
    cycleEndDate: "2024-03-01",
    cycleStartDate: "2024-02-01",
    declinesThisCycle: 2,
    lastDeclineDate: "2024-02-08",
    lastStatementBalanceCents: 68687,
    pendingFeesAndChargesCents: 2090,
    postedTransactions: [
      {
        id: "001",
        amountCents: 300,
        authNumber: "",
        description: "Tesla Inc Supercharger 877-79837485 CA",
        merchantCategories: "Gas/Fuel",
        newBalanceCents: 68987,
        posEntryMode: "Unknown",
        postDate: "2024-02-06",
        transactionDate: "2024-02-06",
      },
      {
        id: "002",
        amountCents: 1932,
        authNumber: "00672",
        description: "Tesla Inc Supercharger 877-79837485 CA",
        merchantCategories: "Gas/Fuel",
        newBalanceCents: 70919,
        posEntryMode: "Unknown",
        postDate: "2024-02-06",
        transactionDate: "2024-02-06",
      },
      {
        id: "003",
        amountCents: 5318,
        authNumber: "007160",
        description: "SHOPRITE SHREWSBURY S1 SHREWSBURY NJ",
        merchantCategories: "Grocery Stores, Supermarkets",
        newBalanceCents: 76237,
        posEntryMode: "Unknown",
        postDate: "2024-02-08",
        transactionDate: "2024-02-08",
      },
    ],
    pendingAuthorizations: [
      {
        id: "004",
        amountCents: 2607,
        authNumber: "004001",
        date: "2024-02-06",
        description: "AUTH GRANTED SHOPRITE SHREWSBURY S1 SHREWSBURY NJ",
        merchantCategories: "Grocery Stores, Supermarkets",
        posEntryMode: "Chip/Smart",
      },
      {
        id: "Q-jnj4PMAE",
        amountCents: 2607,
        authNumber: "",
        date: "2024-02-07",
        description: "AUTH GRANTED SHOPRITE SHREWSBURY S1 SHREWSBURY NJ",
        merchantCategories: "Grocery Stores, Supermarkets",
        posEntryMode: "Chip/Smart",
      },
    ],
    declinedAuthorizations: [
      {
        id: "005",
        amountCents: 300,
        authNumber: "",
        date: "2024-02-06",
        description: "Invalid CVV2 DUNKIN' MOBILE CANTON MA",
        merchantCategories: "Fast Food Restaurants",
        posEntryMode: "Unknown",
        reset: "No",
      },
      {
        id: "006",
        amountCents: 453,
        authNumber: "004001",
        date: "2024-02-08",
        description: "Invalid CVV2 DUNKIN' MOBILE CANTON MA",
        merchantCategories: "Fast Food Restaurants",
        posEntryMode: "Unknown",
        reset: "NM 50",
      },
    ],
  };

export const MOCK_GET_STATEMENT_HISTORY_RESPONSE: GetStatementHistoryResponse =
  {
    statements: [
      {
        adbCashCents: 0,
        adbPurchaseCents: 0,
        adjustmentAmountCents: 0,
        adjustmentsCount: "000",
        balanceCents: 873600,
        cashAmountCents: 0,
        cashBalanceCents: 0,
        cashCount: "000",
        creditAmountCents: 0,
        creditLimitCents: 50000,
        creditsCount: "000",
        daysInCycle: "29",
        delinquentAmountCents: 0,
        dueDate: "2024-03-04",
        fcCashCents: 0,
        fcPurchaseCents: 0,
        lateFeeCents: 0,
        oclAmountCents: 823600,
        oclFeeCents: 0,
        paymentAmountCents: 17900,
        paymentsCount: "001",
        purchaseAmountCents: 0,
        purchaseCount: "000",
        statementDate: "2024-02-09",
        totalAmountDueCents: 841100,
      },
      {
        adbCashCents: 0,
        adbPurchaseCents: 0,
        adjustmentAmountCents: 0,
        adjustmentsCount: "000",
        balanceCents: 891500,
        cashAmountCents: 0,
        cashBalanceCents: 0,
        cashCount: "000",
        creditAmountCents: 0,
        creditLimitCents: 50000,
        creditsCount: "000",
        daysInCycle: "",
        delinquentAmountCents: 0,
        dueDate: "2024-02-04",
        fcCashCents: 0,
        fcPurchaseCents: 0,
        lateFeeCents: 0,
        oclAmountCents: 841500,
        oclFeeCents: 0,
        paymentAmountCents: 314500,
        paymentsCount: "001",
        purchaseAmountCents: 0,
        purchaseCount: "000",
        statementDate: "2024-01-11",
        totalAmountDueCents: 859400,
      },
      {
        adbCashCents: 0,
        adbPurchaseCents: 0,
        adjustmentAmountCents: 0,
        adjustmentsCount: "000",
        balanceCents: 1206000,
        cashAmountCents: 0,
        cashBalanceCents: 0,
        cashCount: "000",
        creditAmountCents: 0,
        creditLimitCents: 50000,
        creditsCount: "000",
        daysInCycle: "",
        delinquentAmountCents: 290300,
        dueDate: "2024-01-04",
        fcCashCents: 0,
        fcPurchaseCents: 0,
        lateFeeCents: 0,
        oclAmountCents: 1156000,
        oclFeeCents: 0,
        paymentAmountCents: 0,
        paymentsCount: "000",
        purchaseAmountCents: 0,
        purchaseCount: "000",
        statementDate: "2023-12-11",
        totalAmountDueCents: 1206000,
      },
      {
        adbCashCents: 0,
        adbPurchaseCents: 0,
        adjustmentAmountCents: 0,
        adjustmentsCount: "000",
        balanceCents: 1206000,
        cashAmountCents: 0,
        cashBalanceCents: 0,
        cashCount: "000",
        creditAmountCents: 0,
        creditLimitCents: 50000,
        creditsCount: "000",
        daysInCycle: "",
        delinquentAmountCents: 266100,
        dueDate: "2023-12-04",
        fcCashCents: 0,
        fcPurchaseCents: 0,
        lateFeeCents: 0,
        oclAmountCents: 1156000,
        oclFeeCents: 0,
        paymentAmountCents: 0,
        paymentsCount: "000",
        purchaseAmountCents: 2000,
        purchaseCount: "001",
        statementDate: "2023-11-10",
        totalAmountDueCents: 1206000,
      },
      {
        adbCashCents: 0,
        adbPurchaseCents: 0,
        adjustmentAmountCents: 0,
        adjustmentsCount: "000",
        balanceCents: 1204000,
        cashAmountCents: 0,
        cashBalanceCents: 0,
        cashCount: "000",
        creditAmountCents: 0,
        creditLimitCents: 50000,
        creditsCount: "000",
        daysInCycle: "",
        delinquentAmountCents: 266100,
        dueDate: "2023-11-04",
        fcCashCents: 0,
        fcPurchaseCents: 0,
        lateFeeCents: 0,
        oclAmountCents: 1154000,
        oclFeeCents: 0,
        paymentAmountCents: 0,
        paymentsCount: "000",
        purchaseAmountCents: 0,
        purchaseCount: "000",
        statementDate: "2023-10-11",
        totalAmountDueCents: 1204000,
      },
      {
        adbCashCents: 0,
        adbPurchaseCents: 0,
        adjustmentAmountCents: 0,
        adjustmentsCount: "000",
        balanceCents: 1204000,
        cashAmountCents: 0,
        cashBalanceCents: 0,
        cashCount: "000",
        creditAmountCents: 0,
        creditLimitCents: 50000,
        creditsCount: "000",
        daysInCycle: "",
        delinquentAmountCents: 217900,
        dueDate: "2023-10-04",
        fcCashCents: 0,
        fcPurchaseCents: 0,
        lateFeeCents: 0,
        oclAmountCents: 1154000,
        oclFeeCents: 0,
        paymentAmountCents: 0,
        paymentsCount: "000",
        purchaseAmountCents: 0,
        purchaseCount: "000",
        statementDate: "2023-09-11",
        totalAmountDueCents: 1204000,
      },
      {
        adbCashCents: 0,
        adbPurchaseCents: 0,
        adjustmentAmountCents: 0,
        adjustmentsCount: "000",
        balanceCents: 1204000,
        cashAmountCents: 0,
        cashBalanceCents: 0,
        cashCount: "000",
        creditAmountCents: 0,
        creditLimitCents: 50000,
        creditsCount: "000",
        daysInCycle: "",
        delinquentAmountCents: 193800,
        dueDate: "2023-09-04",
        fcCashCents: 0,
        fcPurchaseCents: 0,
        lateFeeCents: 0,
        oclAmountCents: 1154000,
        oclFeeCents: 0,
        paymentAmountCents: 0,
        paymentsCount: "000",
        purchaseAmountCents: 0,
        purchaseCount: "000",
        statementDate: "2023-08-11",
        totalAmountDueCents: 1204000,
      },
      {
        adbCashCents: 0,
        adbPurchaseCents: 0,
        adjustmentAmountCents: 0,
        adjustmentsCount: "000",
        balanceCents: 1204000,
        cashAmountCents: 0,
        cashBalanceCents: 0,
        cashCount: "000",
        creditAmountCents: 0,
        creditLimitCents: 50000,
        creditsCount: "000",
        daysInCycle: "",
        delinquentAmountCents: 169700,
        dueDate: "2023-08-04",
        fcCashCents: 0,
        fcPurchaseCents: 0,
        lateFeeCents: 0,
        oclAmountCents: 1154000,
        oclFeeCents: 0,
        paymentAmountCents: 0,
        paymentsCount: "000",
        purchaseAmountCents: 0,
        purchaseCount: "000",
        statementDate: "2023-07-11",
        totalAmountDueCents: 1204000,
      },
      {
        adbCashCents: 0,
        adbPurchaseCents: 0,
        adjustmentAmountCents: 0,
        adjustmentsCount: "000",
        balanceCents: 1204000,
        cashAmountCents: 0,
        cashBalanceCents: 0,
        cashCount: "000",
        creditAmountCents: 0,
        creditLimitCents: 50000,
        creditsCount: "000",
        daysInCycle: "",
        delinquentAmountCents: 145600,
        dueDate: "2023-07-04",
        fcCashCents: 0,
        fcPurchaseCents: 0,
        lateFeeCents: 0,
        oclAmountCents: 1154000,
        oclFeeCents: 0,
        paymentAmountCents: 0,
        paymentsCount: "000",
        purchaseAmountCents: 0,
        purchaseCount: "000",
        statementDate: "2023-06-09",
        totalAmountDueCents: 1204000,
      },
      {
        adbCashCents: 0,
        adbPurchaseCents: 0,
        adjustmentAmountCents: 0,
        adjustmentsCount: "000",
        balanceCents: 1204000,
        cashAmountCents: 0,
        cashBalanceCents: 0,
        cashCount: "000",
        creditAmountCents: 0,
        creditLimitCents: 50000,
        creditsCount: "000",
        daysInCycle: "",
        delinquentAmountCents: 121500,
        dueDate: "2023-06-04",
        fcCashCents: 0,
        fcPurchaseCents: 0,
        lateFeeCents: 0,
        oclAmountCents: 1154000,
        oclFeeCents: 0,
        paymentAmountCents: 0,
        paymentsCount: "000",
        purchaseAmountCents: 0,
        purchaseCount: "000",
        statementDate: "2023-05-10",
        totalAmountDueCents: 1204000,
      },
      {
        adbCashCents: 0,
        adbPurchaseCents: 0,
        adjustmentAmountCents: 0,
        adjustmentsCount: "000",
        balanceCents: 1204000,
        cashAmountCents: 0,
        cashBalanceCents: 0,
        cashCount: "000",
        creditAmountCents: 0,
        creditLimitCents: 50000,
        creditsCount: "000",
        daysInCycle: "",
        delinquentAmountCents: 97400,
        dueDate: "2023-05-04",
        fcCashCents: 0,
        fcPurchaseCents: 0,
        lateFeeCents: 0,
        oclAmountCents: 1154000,
        oclFeeCents: 0,
        paymentAmountCents: 0,
        paymentsCount: "000",
        purchaseAmountCents: 0,
        purchaseCount: "000",
        statementDate: "2023-04-11",
        totalAmountDueCents: 1204000,
      },
      {
        adbCashCents: 0,
        adbPurchaseCents: 0,
        adjustmentAmountCents: 0,
        adjustmentsCount: "000",
        balanceCents: 1204000,
        cashAmountCents: 0,
        cashBalanceCents: 0,
        cashCount: "000",
        creditAmountCents: 0,
        creditLimitCents: 50000,
        creditsCount: "000",
        daysInCycle: "",
        delinquentAmountCents: 73300,
        dueDate: "2023-04-04",
        fcCashCents: 0,
        fcPurchaseCents: 0,
        lateFeeCents: 0,
        oclAmountCents: 1154000,
        oclFeeCents: 0,
        paymentAmountCents: 0,
        paymentsCount: "000",
        purchaseAmountCents: 0,
        purchaseCount: "000",
        statementDate: "2023-03-11",
        totalAmountDueCents: 1204000,
      },
    ],
  };

export const MOCK_LOST_STOLEN_OPTIONS_RESPONSE: LostStolenOptionsResponse = {
  contactTypes: [
    { id: "1", value: "Cardmember" },
    { id: "2", value: "Authorized user" },
    { id: "3", value: "Parent" },
    { id: "11", value: "3rd party known to CM" },
    { id: "12", value: "3rd party unknown to CM" },
    { id: "5", value: "Merchant" },
    { id: "98", value: "Other" },
  ],
  externalStatus: "",
  reasonCode: "00",
  isLoanAccount: false,
  isClosedAccount: false,
  cardBrand: "mc",
  isEmergencyCardEligible: false,
  isRushEligible: false,
  rushFee: "$25",
  replacementFee: "$10",
  rushDeliveryDate: "2025-03-19",
  securityDeptCloseTime: "6pm CT",
  travelDaysAllowedEmergencyCard: "5",
  accountAddress: {
    addressLine1: "1234 South St",
    city: "Austin",
    stateCode: "TX",
    zipcode: "78701",
  },
  workPhone: "5125551234",
  homePhone: "5125551234",
  lossLocations: [
    { id: "1", value: "Home" },
    { id: "2", value: "Auto" },
    { id: "3", value: "Office" },
    { id: "4", value: "Store" },
    { id: "5", value: "Rural" },
    { id: "6", value: "Bar" },
    { id: "7", value: "Hotel/motel" },
    { id: "8", value: "Unknown" },
  ],
  lossStates: [
    { id: "AR", value: "Arkansas" },
    { id: "KS", value: "Kansas" },
    { id: "MI", value: "Michigan" },
    { id: "RI", value: "Rhode Island" },
    { id: "TX", value: "Texas" },
    { id: "VA", value: "Virgina" },
  ],
  lossTypes: [
    { id: "1", value: "Lost card" },
    { id: "2", value: "Stolen" },
    { id: "3", value: "Not received" },
    { id: "4", value: "Fraud app" },
    { id: "5", value: "Counterfeit" },
    { id: "6", value: "Account takeover" },
    { id: "7", value: "All mail and phone" },
  ],
  replacementTypes: [
    { id: "4", value: "Standard" },
    { id: "1", value: "Rush FedEx" },
    { id: "2", value: "Rush Postal Express" },
    { id: "3", value: "FedEx" },
  ],
  shipToTypes: [
    { id: "1", value: "Billing address" },
    { id: "2", value: "Temporary address" },
  ],
  tempAddressReasons: [
    { id: "ta-1", value: "Home address" },
    { id: "ta-2", value: "Parents address" },
    { id: "ta-3", value: "School address" },
    { id: "ta-4", value: "Work address" },
    { id: "ta-5", value: "Vacation/traveling" },
    { id: "ta-6", value: "Security issue w/ billing addr" },
  ],
  tempAddressStates: [
    { id: "AR", value: "Arkansas" },
    { id: "KS", value: "Kansas" },
    { id: "MI", value: "Michigan" },
    { id: "RI", value: "Rhode Island" },
    { id: "TX", value: "Texas" },
    { id: "VA", value: "Virgina" },
  ],
  waysToContact: [
    { id: "1", value: "Home" },
    { id: "2", value: "Work" },
    { id: "3", value: "Other" },
  ],
  onlyYesForWaiveReplacementFee: false,
};

export const MOCK_CREDIT_LINE_INCREASE_ELIGIBILITY: GetCreditLineIncreaseEligibilityResponse =
  {
    maxCreditLineCents: 125000,
    maxIncreaseCents: 75000,
    reasons: [
      {
        id: "7fI2kEP8ra",
        value: "Income Increased",
      },
      {
        id: "EDCPuKIBVQ",
        value: "Credit Score Increased",
      },
      {
        id: "9RHfVUzb0J",
        value: "Other",
      },
    ],
    rejectionReason: null,
    scriptName: "CLI01",
    letterType: null,
    userData: {
      accountNumber: "12345",
      accountSubType: "",
      authorizationFlag: "",
      behaviorScore: 0,
      creditLimitCents: 50000,
      creditLineLastChangeDate: "2024-01-14T02:41:00.000Z",
      currentBalanceCents: 15000,
      cycledOverlimitCount: 0,
      delinquentBucketId: 0,
      externalStatus: "",
      externalStatusReason: "",
      internalStatus: "",
      lastCreditLineChangeCents: 25000,
      ocl10PercentOrGreater: false,
      oclOrDelinquent: false,
      openDate: "2023-01-14T02:41:00.000Z",
      permanentCollectorCode: "",
      totalNumberOfTimesOneCycleDelinquentCount: 0,
      totalNumberOfTimesThreeCyclesDelinquentCount: 0,
      totalNumberOfTimesTwoCyclesDelinquentCount: 0,
    },
  };

export const MOCK_CREDIT_LINE_INCREASE_SUBMIT_RESPONSE: SubmitCreditLineIncreaseResponse =
  {
    scriptName: "CLI02",
  };

export const MOCK_CREDIT_LINE_INCREASE_SUBMIT_NO_PHONE_RESPONSE: SubmitCreditLineIncreaseResponse =
  {
    scriptName: "CLI18",
  };

export const MOCK_DYNAMIC_ERROR_RESPONSE: DynamicErrorResponse = {
  type: "dynamic_error",
  message: "Example dynamic error.",
  errorKey: "example_dynamic_error",
  isOverrideable: true,
};

export const MOCK_GET_CALL_INFO_RESPONSE: GetCallInfoResponse = {
  displayReferenceId: "123",
  referenceId: "123",
};

export const MOCK_GET_TERMS_RESPONSE: GetTermsResponse = {
  aprScript: "APR_001",
  aprTerms: {
    introductoryCashAPRRate: "8.0",
    introductoryPurchaseAPRRate: "6.0",
    introductoryPurchaseExpirationDate: "2028-07-04",
    introductoryPurchaseExpirationMonths: "12",
    levels: [
      {
        cashAPR: "14.0",
        cashAPRSpread: "28.0",
        maxBalanceCents: 100,
        minBalanceCents: 0,
        monthlyBaseCashAPR: "15.0",
        monthlyBasePurchaseAPR: "13.0",
        purchaseAPR: "24.0",
        purchaseAPRSpread: "48.0",
        useCashPrimeRate: true,
        usePurchasePrimeRate: true,
      },
      {
        cashAPR: "14.0",
        cashAPRSpread: "28.0",
        maxBalanceCents: 10000,
        minBalanceCents: 100,
        monthlyBaseCashAPR: "30.0",
        monthlyBasePurchaseAPR: "26.0",
        purchaseAPR: "24.0",
        purchaseAPRSpread: "48.0",
        useCashPrimeRate: true,
        usePurchasePrimeRate: true,
      },
    ],
    tier1PenaltyAPR: "12.0",
    tier1PenaltyAPRSpread: "12.4",
    tier2PenaltyAPR: "24.0",
    tier2PenaltyAPRSpread: "24.4",
    useTier1PenaltyPrimeRate: false,
    useTier2PenaltyPrimeRate: true,
  },
  availableCreditCents: 1000,
  currentTerms: {
    currentCashAPR: "24.9",
    currentCashAPRSpread: "30.0",
    currentPurchaseAPR: "25.9",
    currentPurchaseAPRSpread: "31.0",
    dailyCompounding: "10.0",
    interestGrace: "Purch Only",
    isExternalStatusDisabled: false,
    monthlyCurrentCashAPR: "12.3",
    monthlyCurrentPurchaseAPR: "13.3",
    primeRate: "34.15",
    rewards: [
      {
        endDate: "No Expiration",
        programName: "1.5% Purch & Cash Advances",
        startDate: "2019-07-22",
      },
      {
        endDate: "No Expiration",
        programName: "2% Purch & Cash Advances",
        startDate: "2019-07-22",
      },
      {
        endDate: "No Expiration",
        programName: "3% Purch & Cash Advances",
        startDate: "2019-07-22",
      },
    ],
    useCashPrimeRate: true,
    usePurchasePrimeRate: true,
  },
  fees: {
    annualFee: "Yes",
    cardFeeAmount: "$55 if Credit Lmt = $1000 or over; else $25",
    cardFeeDesc: "Annual",
    cashAdvanceFeeAmount: "$3 or 3%",
    cashAdvanceFeeAmountCents: 3231,
    feeAmountLastChargedCents: 3200,
    feeChargeMonthYear: "2023-07-04",
    feeLastChargedDate: "2023-07-04",
    returnedCheckFee: "$30 or Stmt Amt Due",
  },
  newRateOnTransDate: "2023-07-04",
  next2PricingStrategyCitMethodId: "G23MSG",
  next2PricingStrategyEffectiveDate: "2023-07-04",
  nextPricingStrategyCitMethodId: "G23MSG",
  nextPricingStrategyDate: "2023-07-04",
  pricingStrategy: "CC0%",
  specialHandlingIndicator: "MLA",
};

export const MOCK_PAYMENT_DYNAMIC_ERROR_KEY = "mock_payment_dynamic_error";
export const MOCK_PAYMENT_DYNAMIC_ERROR: DynamicErrorResponse = {
  type: "dynamic_error",
  message: "Example dynamic error, will go away after several tries",
  errorKey: MOCK_PAYMENT_DYNAMIC_ERROR_KEY,
  isOverrideable: false,
};

export const MOCK_GET_PHONE_OPTIONS_RESPONSE: GetPhoneOptionsResponse = {
  inactivationReasons: [
    {
      id: "105",
      value: "Temp. Disc",
      selectable: false,
      consentRevoke: false,
      defaultReactivationDate: 5,
      inactivationSourceTypes: [],
      inactivationDeliveryTypes: [],
    },
    {
      id: "108",
      value: "Req No Calls-CM Rsdnce",
      selectable: false,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [
        {
          id: "CARD_MEMBER",
          value: "Card Member",
          selectable: true,
        },
        {
          id: "THIRD_PARTY_LIVING_WITH_CM",
          value: "3rd Party Living With CM",
          selectable: true,
        },
      ],
      inactivationDeliveryTypes: [
        { id: "VERBAL", value: "Verbal", selectable: true },
      ],
    },
    {
      id: "109",
      value: "Neighbor / Nearby",
      selectable: false,
      consentRevoke: true,
      defaultReactivationDate: 0,
      inactivationSourceTypes: [],
      inactivationDeliveryTypes: [],
    },
    {
      id: "112",
      value: "NLIS",
      selectable: false,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [],
      inactivationDeliveryTypes: [],
    },
    {
      id: "114",
      value: "CNBCAD",
      selectable: false,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [],
      inactivationDeliveryTypes: [],
    },
    {
      id: "116",
      value: "Req No Calls-Not CM Resdnce",
      selectable: false,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [
        {
          id: "CARD_MEMBER",
          value: "Card Member",
          selectable: true,
        },
        {
          id: "THIRD_PARTY_NOT_LIVING_WITH_CM",
          value: "3rd Party Not Living With CM",
          selectable: true,
        },
      ],
      inactivationDeliveryTypes: [
        { id: "VERBAL", value: "Verbal", selectable: true },
      ],
    },
    {
      id: "118",
      value: "Not a Phone Number",
      selectable: false,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [],
      inactivationDeliveryTypes: [],
    },
    {
      id: "119",
      value: "Temp NAC/Unavailable",
      selectable: false,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [],
      inactivationDeliveryTypes: [],
    },
    {
      id: "120",
      value: "Neustar",
      selectable: false,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [],
      inactivationDeliveryTypes: [],
    },
    {
      id: "113",
      value: "Other",
      selectable: false,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [],
      inactivationDeliveryTypes: [],
    },
    {
      id: "104",
      value: "Wrong Number",
      selectable: true,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [],
      inactivationDeliveryTypes: [],
    },
    {
      id: "121",
      value: "System Message",
      selectable: true,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [],
      inactivationDeliveryTypes: [],
    },
    {
      id: "106",
      value: "Hang Up",
      selectable: true,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [],
      inactivationDeliveryTypes: [],
    },
    {
      id: "107",
      value: "DNC One Number",
      selectable: true,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [
        {
          id: "CARD_MEMBER",
          value: "Card Member",
          selectable: true,
        },
      ],
      inactivationDeliveryTypes: [
        { id: "WRITTEN", value: "Written", selectable: true },
      ],
    },
    {
      id: "110",
      value: "DNC POE",
      selectable: true,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [
        {
          id: "CARD_MEMBER",
          value: "Card Member",
          selectable: true,
        },
        { id: "EMPLOYER", value: "Employer", selectable: true },
      ],
      inactivationDeliveryTypes: [
        { id: "VERBAL", value: "Verbal", selectable: true },
        { id: "WRITTEN", value: "Written", selectable: true },
      ],
    },
    {
      id: "111",
      value: "DNC 3rd Party",
      selectable: true,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [
        {
          id: "THIRD_PARTY_NOT_LIVING_WITH_CM",
          value: "3rd Party Not Living With CM",
          selectable: true,
        },
      ],
      inactivationDeliveryTypes: [
        { id: "VERBAL", value: "Verbal", selectable: true },
        { id: "WRITTEN", value: "Written", selectable: true },
      ],
    },
    {
      id: "115",
      value: "NLE",
      selectable: true,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [],
      inactivationDeliveryTypes: [],
    },
    {
      id: "117",
      value: "Wrong Number 2nd Attempt",
      selectable: true,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [],
      inactivationDeliveryTypes: [],
    },
    {
      id: "1",
      value: "DNC All Numbers",
      selectable: true,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [
        {
          id: "CARD_MEMBER",
          value: "Card Member",
          selectable: true,
        },
      ],
      inactivationDeliveryTypes: [
        { id: "WRITTEN", value: "Written", selectable: true },
      ],
    },
    {
      id: "2",
      value: "Jail",
      selectable: true,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [],
      inactivationDeliveryTypes: [],
    },
    {
      id: "3",
      value: "Deceased",
      selectable: true,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [
        {
          id: "THIRD_PARTY_LIVING_WITH_CM",
          value: "3rd Party Living With CM",
          selectable: true,
        },
        {
          id: "THIRD_PARTY_NOT_LIVING_WITH_CM",
          value: "3rd Party Not Living With CM",
          selectable: true,
        },
        { id: "EMPLOYER", value: "Employer", selectable: true },
        { id: "ATTORNEY", value: "Attorney", selectable: true },
      ],
      inactivationDeliveryTypes: [
        { id: "VERBAL", value: "Verbal", selectable: true },
        { id: "WRITTEN", value: "Written", selectable: true },
      ],
    },
    {
      id: "4",
      value: "Legal Representation",
      selectable: true,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [
        {
          id: "CARD_MEMBER",
          value: "Card Member",
          selectable: true,
        },
        { id: "ATTORNEY", value: "Attorney", selectable: true },
      ],
      inactivationDeliveryTypes: [
        { id: "VERBAL", value: "Verbal", selectable: true },
        { id: "WRITTEN", value: "Written", selectable: true },
      ],
    },
    {
      id: "5",
      value: "Cease Communication CM",
      selectable: true,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [
        {
          id: "CARD_MEMBER",
          value: "Card Member",
          selectable: true,
        },
      ],
      inactivationDeliveryTypes: [
        { id: "WRITTEN", value: "Written", selectable: true },
      ],
    },
    {
      id: "7",
      value: "Cease Communication Legal",
      selectable: true,
      consentRevoke: true,
      defaultReactivationDate: -1,
      inactivationSourceTypes: [
        { id: "ATTORNEY", value: "Attorney", selectable: true },
        {
          id: "SETTLEMENT_COMPANY",
          value: "Settlement Company",
          selectable: true,
        },
        {
          id: "CCCS_DEBT_MGMT",
          value: "CCCS/Debt Management",
          selectable: true,
        },
        { id: "OTHER", value: "Other", selectable: false },
      ],
      inactivationDeliveryTypes: [
        { id: "WRITTEN", value: "Written", selectable: true },
      ],
    },
    {
      id: "6",
      value: "Bankruptcy",
      selectable: true,
      consentRevoke: false,
      defaultReactivationDate: 0,
      inactivationSourceTypes: [
        {
          id: "CARD_MEMBER",
          value: "Card Member",
          selectable: true,
        },
        { id: "ATTORNEY", value: "Attorney", selectable: true },
      ],
      inactivationDeliveryTypes: [
        { id: "VERBAL", value: "Verbal", selectable: true },
        { id: "WRITTEN", value: "Written", selectable: true },
      ],
    },
  ],
  nameSuffixes: [
    { id: "JR", value: "JR", selectable: true },
    { id: "SR", value: "SR", selectable: true },
    { id: "II", value: "II", selectable: true },
    { id: "III", value: "III", selectable: true },
    { id: "IV", value: "IV", selectable: true },
    { id: "SECOND", value: "2ND", selectable: true },
    { id: "THIRD", value: "3RD", selectable: true },
    { id: "FOURTH", value: "4TH", selectable: true },
  ],
  pecSources: [
    { id: "ACQ_PAPER", value: "ACQ Paper", selectable: false },
    { id: "ACQ_ONLINE", value: "ACQ Online", selectable: false },
    { id: "ACQ_TELEPHONE", value: "ACQ Telephone", selectable: false },
    { id: "WEB_UIR", value: "Web UIR", selectable: false },
    { id: "TEXT_BANKING", value: "Text Banking", selectable: false },
    { id: "GET_ANI", value: "Get ANI", selectable: false },
    { id: "CORRESPONDENCE", value: "Correspondence", selectable: true },
    { id: "PHONE_CONVERSATION", value: "Phone Conversation", selectable: true },
    { id: "SECURE_MAIL", value: "Secure Mail", selectable: true },
    { id: "OTHER", value: "Other", selectable: false },
    { id: "NEUSTAR", value: "Neustar", selectable: false },
    { id: "WEB_ACTION_PAGE", value: "Web Action Page", selectable: false },
    {
      id: "MOBILE_WEB_ACTION_PAGE",
      value: "Mobile Web Action Page",
      selectable: false,
    },
  ],
  pecStatusTypes: [
    { id: "PEC_YES", value: "Yes", selectable: true },
    { id: "PEC_NO", value: "No", selectable: true },
    {
      id: "PEC_NOT_SPECIFIED_OR_UNKNOWN",
      value: "Not Specified",
      selectable: true,
    },
  ],
  phoneOwnerTypes: [
    { id: "CARD_MEMBER", value: "Card Member", selectable: true },
    { id: "PARENT", value: "Parent", selectable: true },
    { id: "MOTHER", value: "Mother", selectable: true },
    { id: "FATHER", value: "Father", selectable: true },
    { id: "NEIGHBOR", value: "Neighbor", selectable: true },
    { id: "ROOMMATE", value: "Roommate", selectable: true },
    { id: "EMPLOYER", value: "Employer", selectable: true },
    { id: "ATTORNEY", value: "Attorney", selectable: true },
    { id: "SISTER", value: "Sister", selectable: true },
    { id: "BROTHER", value: "Brother", selectable: true },
    { id: "GRANDPARENT", value: "Grandparent", selectable: true },
    { id: "RELATIVE", value: "Relative", selectable: true },
    { id: "FRIEND", value: "Friend", selectable: true },
    { id: "BANK", value: "Bank", selectable: true },
    { id: "MERCHANT", value: "Merchant", selectable: true },
    { id: "SPOUSE", value: "Spouse", selectable: true },
    { id: "CCCS", value: "CCCS", selectable: true },
    { id: "IN_LAWS", value: "In-Laws", selectable: true },
    { id: "OUTSIDE_AGENCY", value: "Outside Agency", selectable: true },
    { id: "OTHER", value: "Other", selectable: true },
    { id: "UNKNOWN", value: "Unknown", selectable: false },
  ],
  phoneSources: [
    { id: "CC", value: "CC", selectable: false },
    { id: "ST", value: "ST", selectable: false },
    { id: "THIRD_P", value: "3P", selectable: false },
    { id: "GA", value: "GA", selectable: false },
    { id: "NT", value: "NT", selectable: false },
    { id: "AQ", value: "AQ", selectable: false },
    { id: "AP", value: "AP", selectable: false },
    { id: "CI", value: "CI", selectable: false },
    { id: "FS", value: "FS", selectable: false },
    { id: "DDA", value: "DDA", selectable: false },
    { id: "TB", value: "TB", selectable: false },
    { id: "NSTR", value: "NSTR", selectable: false },
    { id: "FSMA", value: "FSMA", selectable: false },
    { id: "OTPFS", value: "OTPFS", selectable: false },
    { id: "DVFCT", value: "DVFCT", selectable: false },
  ],
  phoneTypes: [
    { id: "CELL", value: "Cell", selectable: true },
    { id: "FAX", value: "Fax", selectable: true },
    { id: "HOME", value: "Home", selectable: true },
    { id: "PAGER", value: "Pager", selectable: true },
    { id: "POSSIBLE_HOME", value: "Possible Home", selectable: true },
    { id: "POSSIBLE_WORK", value: "Possible Work", selectable: true },
    { id: "SCHOOL", value: "School", selectable: true },
    { id: "WORK", value: "Work", selectable: true },
    { id: "OTHER", value: "Other", selectable: true },
    { id: "UNKNOWN", value: "Unknown", selectable: false },
  ],
  updateFiservTypes: [
    { id: "UPDATE_FDR_HOME", value: "Primary", selectable: true },
    { id: "UPDATE_FDR_WORK", value: "Secondary", selectable: true },
    { id: "UPDATE_NEITHER", value: "Neither", selectable: true },
  ],
  restrictionFrequencies: [
    { id: "ONE_CALL_PER_DAY", value: "1 Call Per Day", selectable: true },
    { id: "ONE_CALL_PER_WEEK", value: "1 Call Per Week", selectable: true },
    { id: "ONE_CALL_PER_MONTH", value: "1 Call Per Month", selectable: true },
    {
      id: "LEGACY_RESTRICTION",
      value: "Legacy Restriction",
      selectable: false,
    },
    { id: "NONE", value: "None", selectable: false },
  ],
  restrictionDays: [
    { id: "MONDAY", value: "Monday", selectable: true },
    { id: "TUESDAY", value: "Tuesday", selectable: true },
    { id: "WEDNESDAY", value: "Wednesday", selectable: true },
    { id: "THURSDAY", value: "Thursday", selectable: true },
    { id: "FRIDAY", value: "Friday", selectable: true },
    { id: "SATURDAY", value: "Saturday", selectable: true },
    { id: "SUNDAY", value: "Sunday", selectable: true },
  ],
};

export const MOCK_GET_PHONES_RESPONSE: GetPhonesResponse = {
  primaryPhone: "0000000000",
  secondaryPhone: "0000000000",
  phoneContacts: [
    {
      phoneID: nanoid(),
      phoneNumber: "1234567890",
      extension: "",
      ownerType: "CARD_MEMBER",
      ownerFirstName: "John",
      ownerLastName: "Smith",
      ownerSuffix: null,
      phoneType: "CELL",
      consentStatus: "PEC_YES",
      consentSourceType: "PHONE_CONVERSATION",
      consentCapturedDate: new Date(),
      lastVerifiedDate: new Date(),
      lastCapturedDate: new Date(),
      firstCapturedDate: new Date(),
      sourceType: [
        {
          count: 1,
          source: "CC",
        },
      ],
      memos: [
        {
          id: nanoid(),
          note: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          createDate: new Date(),
          enteredBy: "151",
        },
        {
          id: nanoid(),
          note: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          createDate: new Date(),
          enteredBy: "151",
        },
        {
          id: nanoid(),
          note: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          createDate: new Date(),
          enteredBy: "151",
        },
        {
          id: nanoid(),
          note: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          createDate: new Date(),
          enteredBy: "151",
        },
        {
          id: nanoid(),
          note: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          createDate: new Date(),
          enteredBy: "151",
        },
        {
          id: nanoid(),
          note: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          createDate: new Date(),
          enteredBy: "151",
        },
      ],
      restriction: {
        restrictionId: nanoid(),
        restrictionDays: ["MONDAY", "WEDNESDAY", "FRIDAY"],
        restrictionLiftDate: new Date("2075-01-02T00:00:00.000-05:00"),
        restrictionFrequency: "ONE_CALL_PER_DAY",
      },
      inactivation: null,
      isPrimary: true,
      isSecondary: true,
    },
    {
      phoneID: nanoid(),
      phoneNumber: "5555555551",
      extension: "",
      ownerType: "SPOUSE",
      ownerFirstName: "Jane",
      ownerLastName: "Joe",
      ownerSuffix: null,
      phoneType: "CELL",
      consentStatus: "PEC_NO",
      consentSourceType: "WEB_ACTION_PAGE",
      consentCapturedDate: new Date(),
      lastVerifiedDate: new Date(),
      lastCapturedDate: addDays(new Date(), 1),
      firstCapturedDate: new Date(),
      sourceType: [
        {
          count: 1,
          source: "CC",
        },
      ],
      memos: [],
      restriction: null,
      inactivation: null,
      isPrimary: false,
      isSecondary: true,
    },
    {
      phoneID: nanoid(),
      phoneNumber: "1029384756",
      extension: "",
      ownerType: "FATHER",
      ownerFirstName: "Bob",
      ownerLastName: "Duncan",
      ownerSuffix: "III",
      phoneType: "WORK",
      consentStatus: "PEC_NOT_SPECIFIED_OR_UNKNOWN",
      consentSourceType: "MOBILE_WEB_ACTION_PAGE",
      consentCapturedDate: new Date(),
      lastVerifiedDate: null,
      lastCapturedDate: new Date(),
      firstCapturedDate: new Date(),
      sourceType: [
        {
          count: 1,
          source: "CC",
        },
      ],
      memos: [],
      restriction: {
        restrictionId: nanoid(),
        restrictionDays: ["MONDAY", "WEDNESDAY", "FRIDAY"],
        restrictionLiftDate: new Date("2075-01-02T00:00:00.000-05:00"),
        restrictionFrequency: "ONE_CALL_PER_DAY",
      },
      inactivation: {
        inactivationId: nanoid(),
        inactivationReasonId: "105",
        inactivationDate: new Date(),
        reactivationDate: null,
        inactivationDeliveryType: "UNKNOWN",
        inactivationSourceType: "UNKNOWN",
      },
      isPrimary: false,
      isSecondary: false,
    },
    {
      phoneID: nanoid(),
      phoneNumber: "1029384756",
      extension: "",
      ownerType: "FATHER",
      ownerFirstName: "Bob",
      ownerLastName: "Duncan",
      ownerSuffix: "III",
      phoneType: "WORK",
      consentStatus: "PEC_NOT_SPECIFIED_OR_UNKNOWN",
      consentSourceType: "MOBILE_WEB_ACTION_PAGE",
      consentCapturedDate: new Date(),
      lastVerifiedDate: null,
      lastCapturedDate: new Date(),
      firstCapturedDate: new Date(),
      sourceType: [
        {
          count: 1,
          source: "CC",
        },
      ],
      memos: [],
      restriction: {
        restrictionId: nanoid(),
        restrictionDays: ["MONDAY", "WEDNESDAY", "FRIDAY"],
        restrictionLiftDate: new Date("2075-01-02T00:00:00.000-05:00"),
        restrictionFrequency: "ONE_CALL_PER_DAY",
      },
      inactivation: null,
      isPrimary: true,
      isSecondary: false,
    },
    {
      phoneID: nanoid(),
      phoneNumber: "5555555551",
      extension: "222",
      ownerType: "BROTHER",
      ownerFirstName: "Billy",
      ownerLastName: "Bill",
      ownerSuffix: null,
      phoneType: "WORK",
      consentStatus: "PEC_NO",
      consentSourceType: "WEB_ACTION_PAGE",
      consentCapturedDate: new Date(),
      lastVerifiedDate: addDays(new Date(), -1),
      lastCapturedDate: new Date(),
      firstCapturedDate: new Date(),
      sourceType: [
        {
          count: 1,
          source: "CC",
        },
      ],
      memos: [],
      restriction: null,
      inactivation: null,
      isPrimary: false,
      isSecondary: true,
    },
    {
      phoneID: nanoid(),
      phoneNumber: "5555555551",
      extension: "111",
      ownerType: "SISTER",
      ownerFirstName: "Jilly",
      ownerLastName: "Jill",
      ownerSuffix: null,
      phoneType: "WORK",
      consentStatus: "PEC_NO",
      consentSourceType: "WEB_ACTION_PAGE",
      consentCapturedDate: new Date(),
      lastVerifiedDate: new Date(),
      lastCapturedDate: addDays(new Date(), -1),
      firstCapturedDate: new Date(),
      sourceType: [
        {
          count: 1,
          source: "CC",
        },
      ],
      memos: [],
      restriction: null,
      inactivation: null,
      isPrimary: false,
      isSecondary: true,
    },
    {
      phoneID: nanoid(),
      phoneNumber: "1029384756",
      extension: "",
      ownerType: "MOTHER",
      ownerFirstName: "JANE",
      ownerLastName: "DOE",
      ownerSuffix: "III",
      phoneType: "WORK",
      consentStatus: "PEC_NOT_SPECIFIED_OR_UNKNOWN",
      consentSourceType: "MOBILE_WEB_ACTION_PAGE",
      consentCapturedDate: new Date(),
      lastVerifiedDate: null,
      lastCapturedDate: addDays(new Date(), -1),
      firstCapturedDate: new Date(),
      sourceType: [
        {
          count: 1,
          source: "CC",
        },
      ],
      memos: [],
      restriction: null,
      inactivation: {
        inactivationId: nanoid(),
        inactivationReasonId: "4",
        inactivationDate: new Date(),
        reactivationDate: null,
        inactivationDeliveryType: "VERBAL",
        inactivationSourceType: "ATTORNEY",
      },
      isPrimary: false,
      isSecondary: false,
    },
    {
      phoneID: nanoid(),
      phoneNumber: "2054025002",
      extension: "754",
      ownerType: "MOTHER",
      ownerFirstName: "CARD",
      ownerLastName: "MEMBER",
      ownerSuffix: "III",
      phoneType: "WORK",
      consentStatus: "PEC_NOT_SPECIFIED_OR_UNKNOWN",
      consentSourceType: "MOBILE_WEB_ACTION_PAGE",
      consentCapturedDate: new Date(),
      lastVerifiedDate: null,
      lastCapturedDate: addDays(new Date(), -1),
      firstCapturedDate: new Date(),
      sourceType: [
        {
          count: 1,
          source: "CC",
        },
      ],
      memos: [],
      restriction: null,
      inactivation: {
        inactivationId: nanoid(),
        inactivationReasonId: "4",
        inactivationDate: new Date(),
        reactivationDate: null,
        inactivationDeliveryType: "VERBAL",
        inactivationSourceType: "ATTORNEY",
      },
      isPrimary: false,
      isSecondary: false,
    },
    {
      phoneID: nanoid(),
      phoneNumber: "2064025001",
      extension: "",
      ownerType: "MOTHER",
      ownerFirstName: "CARD",
      ownerLastName: "MEMBER",
      ownerSuffix: "III",
      phoneType: "WORK",
      consentStatus: "PEC_NOT_SPECIFIED_OR_UNKNOWN",
      consentSourceType: "MOBILE_WEB_ACTION_PAGE",
      consentCapturedDate: new Date(),
      lastVerifiedDate: null,
      lastCapturedDate: addDays(new Date(), -1),
      firstCapturedDate: new Date(),
      sourceType: [
        {
          count: 1,
          source: "CC",
        },
      ],
      memos: [],
      restriction: null,
      inactivation: {
        inactivationId: nanoid(),
        inactivationReasonId: "4",
        inactivationDate: new Date(),
        reactivationDate: null,
        inactivationDeliveryType: "VERBAL",
        inactivationSourceType: "ATTORNEY",
      },
      isPrimary: false,
      isSecondary: false,
    },
    {
      phoneID: nanoid(),
      phoneNumber: "2054025010",
      extension: "",
      ownerType: "MOTHER",
      ownerFirstName: "CARD",
      ownerLastName: "MEMBER",
      ownerSuffix: "III",
      phoneType: "WORK",
      consentStatus: "PEC_NOT_SPECIFIED_OR_UNKNOWN",
      consentSourceType: "MOBILE_WEB_ACTION_PAGE",
      consentCapturedDate: new Date(),
      lastVerifiedDate: null,
      lastCapturedDate: addDays(new Date(), -1),
      firstCapturedDate: new Date(),
      sourceType: [
        {
          count: 1,
          source: "CC",
        },
      ],
      memos: [],
      restriction: null,
      inactivation: {
        inactivationId: nanoid(),
        inactivationReasonId: "4",
        inactivationDate: new Date(),
        reactivationDate: null,
        inactivationDeliveryType: "VERBAL",
        inactivationSourceType: "ATTORNEY",
      },
      isPrimary: false,
      isSecondary: false,
    },
    {
      phoneID: nanoid(),
      phoneNumber: "2064025001",
      extension: "201",
      ownerType: "MOTHER",
      ownerFirstName: "CARD",
      ownerLastName: "MEMBER",
      ownerSuffix: "III",
      phoneType: "WORK",
      consentStatus: "PEC_NOT_SPECIFIED_OR_UNKNOWN",
      consentSourceType: "MOBILE_WEB_ACTION_PAGE",
      consentCapturedDate: new Date(),
      lastVerifiedDate: null,
      lastCapturedDate: addDays(new Date(), -1),
      firstCapturedDate: new Date(),
      sourceType: [
        {
          count: 1,
          source: "CC",
        },
      ],
      memos: [],
      restriction: null,
      inactivation: {
        inactivationId: nanoid(),
        inactivationReasonId: "4",
        inactivationDate: new Date(),
        reactivationDate: null,
        inactivationDeliveryType: "VERBAL",
        inactivationSourceType: "ATTORNEY",
      },
      isPrimary: false,
      isSecondary: false,
    },
  ],
};

export const MOCK_CUSTOMER_INFO: CustomerInfo = {
  alternateEmailVerifiedStatus: {
    date: "2023-06-15",
    dueForVerification: true,
  },
  billingAddress: {
    addressLine1: "1234 Commerce Street",
    addressLine2: "Apt 101",
    city: "Austin",
    lastAddressDateChange: "2025-05-06",
    state: "TX",
    zip: "78701",
  },
  billingAddressVerifiedStatus: {
    date: "2025-05-06",
    dueForVerification: false,
  },
  contactPreference: {
    EMAIL: 1,
    TEXT_MESSAGE: 4,
    TELEPHONE_CALL: null,
    LETTER: null,
  },
  contactPreferenceOptions: [
    {
      id: "EMAIL",
      value: "Email",
    },
    {
      id: "TEXT_MESSAGE",
      value: "Text Message",
    },
    {
      id: "TELEPHONE_CALL",
      value: "Telephone Call",
    },
    {
      id: "LETTER",
      value: "Letter",
    },
  ],
  contactPreferenceVerifiedStatus: {
    date: "2025-05-06",
    dueForVerification: true,
  },
  dateOfBirthVerifiedStatus: {
    date: "2025-05-06",
    dueForVerification: false,
  },
  email: {
    alternateEmail: "ebonyblack@gmail.com",
    emailOptOut: false,
    primaryEmail: "ebonyblack@gmail.com",
    isPaperless: true,
  },
  emailOptOutVerifiedStatus: {
    date: "2025-05-06",
    dueForVerification: true,
  },
  income: {
    source: "",
  },
  incomeVerifiedStatus: {
    date: "2025-05-06",
    dueForVerification: false,
  },
  language: {
    languagePreferenceId: "1",
    otherLanguage: null,
  },
  languageOptions: [
    {
      id: "1",
      value: "ENGLISH",
    },
    {
      id: "2",
      value: "SPANISH",
    },
    {
      id: "3",
      value: "OTHER",
    },
  ],
  languageVerifiedStatus: {
    date: "2025-05-06",
    dueForVerification: true,
  },
  mothersMaidenNameVerifiedStatus: {
    date: "2025-05-06",
    dueForVerification: false,
  },
  permissionToDiscuss: {
    contacts: [
      {
        firstName: "James",
        lastName: "Black",
        relationship: { id: "1", relationship: "Employer" },
      },
      {
        firstName: "Anthony",
        lastName: "Jones",
        relationship: { id: "2", relationship: "Friend" },
      },
      {
        firstName: "Sam",
        lastName: "Smith",
        relationship: { id: "3", relationship: "Brother" },
      },
      {
        firstName: "Jane",
        lastName: "Doe",
        relationship: { id: "4", relationship: "Sister" },
      },
      {
        firstName: "John",
        lastName: "Doe",
        relationship: { id: "5", relationship: "Cousin" },
      },
    ],
  },
  permissionToDiscussVerifiedStatus: {
    date: "2025-05-06",
    dueForVerification: false,
  },
  primaryEmailVerifiedStatus: {
    date: "2025-05-06",
    dueForVerification: true,
  },
  school: {
    graduationStatus: null,
    graduationDate: "05/26",
    school: "University of Texas",
  },
  schoolVerifiedStatus: {
    date: "2025-05-06",
    dueForVerification: false,
  },
  security: {
    dateOfBirth: "1982-01-02",
    mothersMaidenName: "Smith",
    securityHint: "",
    securityWord: "",
    ssnLast4: "x2127",
  },
  securityVerifiedStatus: {
    date: "2025-05-06",
    dueForVerification: true,
  },
  ssnLast4VerifiedStatus: {
    date: "2025-05-06",
    dueForVerification: false,
  },
  showLanguageSection: true,
  showAddressWarning: true,
};

export const MOCK_CHANGED_HISTORY_RESPONSE: GetChangedHistoryResponse = {
  results: [
    {
      address: "363 W Anchor Dr. Cypress, CA 90630 5154",
      agent: "BKN",
      cellPhone: "5120000000",
      changedDate: "2025-06-24",
      dateOfBirth: "",
      languagePreference: "spanish",
      mothersMaidenName: "",
      preferredContactMethod: "ContactPrefCall",
      primaryEmail: "",
      school: "",
      secondaryEmail: "",
      ssnLast4: "",
      incomeSource: "Test Source",
    },
    {
      address: "",
      agent: "BKN",
      cellPhone: "5120000000",
      changedDate: "2025-06-24",
      dateOfBirth: "1982-01-01",
      languagePreference: "english",
      mothersMaidenName: "",
      preferredContactMethod: "ContactPrefCall",
      primaryEmail: "",
      school: "University of Texas",
      secondaryEmail: "",
      ssnLast4: "",
      incomeSource: "",
    },
    {
      address: "",
      agent: "BKN",
      cellPhone: "5120000000",
      changedDate: "2025-06-24",
      dateOfBirth: "",
      languagePreference: "",
      mothersMaidenName: "Smith",
      preferredContactMethod: "ContactPrefCall",
      primaryEmail: "ebonyblack@gmail.com",
      school: "",
      secondaryEmail: "ebonyblack@gmail.com",
      ssnLast4: "x2127",
      incomeSource: "Test Source",
    },
  ],
};

export const MOCK_ZIPCODE_INFO: GetCitiesByZipcodeResponse = {
  results: [
    {
      city: "Austin",
      state: "TX",
    },
    {
      city: "Dallas",
      state: "TX",
    },
    {
      city: "Houston",
      state: "TX",
    },
  ],
};

export const MOCK_VERIFIED_HISTORY_RESPONSE: GetVerifiedHistoryResponse = {
  results: [
    {
      addressVerified: true,
      agent: "BKN",
      dateOfBirthVerified: true,
      emailOptoutVerified: true,
      incomeSourceVerified: false,
      mothersMaidenNameVerified: false,
      permissionToDiscussVerified: true,
      primaryEmailVerified: true,
      schoolVerified: true,
      secondaryEmailVerified: true,
      securityVerified: true,
      ssnLast4Verified: true,
      verifiedDate: "1982-01-01",
    },
    {
      addressVerified: false,
      agent: "BKN",
      dateOfBirthVerified: true,
      emailOptoutVerified: false,
      incomeSourceVerified: true,
      mothersMaidenNameVerified: true,
      permissionToDiscussVerified: false,
      primaryEmailVerified: false,
      schoolVerified: false,
      secondaryEmailVerified: false,
      securityVerified: false,
      ssnLast4Verified: false,
      verifiedDate: "1982-01-01",
    },
    {
      addressVerified: true,
      agent: "BKN",
      dateOfBirthVerified: true,
      emailOptoutVerified: true,
      incomeSourceVerified: true,
      mothersMaidenNameVerified: false,
      permissionToDiscussVerified: true,
      primaryEmailVerified: true,
      schoolVerified: false,
      secondaryEmailVerified: true,
      securityVerified: true,
      ssnLast4Verified: true,
      verifiedDate: "1982-01-01",
    },
  ],
};

export const MOCK_STATEMENTS_RESPONSE: StatementsResp = {
  statements: [
    {
      isProcessing: true,
      statementDate: "2024-01-31",
      title: "January 31, 2024",
      url: null,
    },
    {
      isProcessing: false,
      statementDate: "2023-12-31",
      title: "December 31, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: "2023-11-30",
      title: "November 30, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: "2023-10-31",
      title: "October 31, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: "2023-09-30",
      title: "September 30, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: "2023-08-31",
      title: "August 31, 2023",
      url: null,
    },
    {
      isProcessing: false,
      statementDate: "2023-07-31",
      title: "July 31, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: "2023-06-30",
      title: "June 30, 2023",
      url: null,
    },
    {
      isProcessing: false,
      statementDate: "2023-05-31",
      title: "May 31, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: "2023-04-31",
      title: "April 30, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: "2023-03-31",
      title: "March 31, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: "2023-02-28",
      title: "February 28, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
  ],
  viewByOptions: [
    {
      id: "0",
      value: "Last 12 Statements",
    },
    {
      id: "2024",
      value: "2024",
    },
    {
      id: "2023",
      value: "2023",
    },
    {
      id: "2022",
      value: "2022",
    },
    {
      id: "2021",
      value: "2021",
    },
    {
      id: "2020",
      value: "2020",
    },
  ],
};

export const MOCK_STATEMENTS_RESPONSE_NO_VIEWBY: StatementsResp = {
  statements: [
    {
      isProcessing: true,
      statementDate: "2024-01-31",
      title: "January 31, 2024",
      url: null,
    },
    {
      isProcessing: false,
      statementDate: "2023-12-31",
      title: "December 31, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: "2023-11-30",
      title: "November 30, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: "2023-10-31",
      title: "October 31, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: "2023-09-30",
      title: "September 30, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: "2023-08-31",
      title: "August 31, 2023",
      url: null,
    },
    {
      isProcessing: false,
      statementDate: "2023-07-31",
      title: "July 31, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: "2023-06-30",
      title: "June 30, 2023",
      url: null,
    },
    {
      isProcessing: false,
      statementDate: "2023-05-31",
      title: "May 31, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: "2023-04-31",
      title: "April 30, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: "2023-03-31",
      title: "March 31, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: "2023-02-28",
      title: "February 28, 2023",
      url: "https://www.placecats.com/louie/600/600",
    },
  ],
  viewByOptions: null,
};

export const MOCK_STATEMENTS_RESPONSE_SINGLE_YEAR = (
  year: string,
): StatementsResp => ({
  statements: [
    {
      isProcessing: false,
      statementDate: `${year}-12-31`,
      title: `December 31, ${year}`,
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: `${year}-11-30`,
      title: `November 30, ${year}`,
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: `${year}-10-31`,
      title: `October 31, ${year}`,
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: `${year}-09-30`,
      title: `September 30, ${year}`,
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: `${year}-08-31`,
      title: `August 31, ${year}`,
      url: null,
    },
    {
      isProcessing: false,
      statementDate: `${year}-07-31`,
      title: `July 31, ${year}`,
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: `${year}-06-30`,
      title: `June 30, ${year}`,
      url: null,
    },
    {
      isProcessing: false,
      statementDate: `${year}-05-31`,
      title: `May 31, ${year}`,
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: `${year}-04-31`,
      title: `April 30, ${year}`,
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: `${year}-03-31`,
      title: `March 31, ${year}`,
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: `${year}-02-28`,
      title: `February 28, ${year}`,
      url: "https://www.placecats.com/louie/600/600",
    },
    {
      isProcessing: false,
      statementDate: `${year}-01-31`,
      title: `January 31, ${year}`,
      url: "https://www.placecats.com/louie/600/600",
    },
  ],
  viewByOptions: null,
});

export const MOCK_PAPERLESS_SETTINGS_RESPONSE: GetPaperlessSettingsResponse = {
  email: {
    alternateEmail: "ebonyblack@gmail.com",
    emailOptOut: false,
    primaryEmail: "ebonyblack@gmail.com",
  },
  onlineStatementEmailOptOut: false,
  paperlessServiceOptOut: false,
};

export const MOCK_GET_CARD_ACTIVATION_INFO: GetCardActivationInfoResponse = {
  pageTitle: "Required Information",
  activatedPageTitle: "Continuation Script: Open > 6 Months",
  scriptName: "",
  showFields: true,
  activated: false,
  accountOpenLongerThanSixMonths: true,
  ssnLast4: "1234",
  formattedDOB: "01/01/2000",
  creditLimitCents: 50000,
};

export const MOCK_SUBMIT_CARD_ACTIVATION: SubmitCardActivationResponse = {
  activatedPageTitle: "Continuation Script: Open > 6 Months",
  scriptName: "",
};

export const MOCK_GET_TEXT_BANKING_SERVICES: GetTextBankingServicesResponse = {
  fraudAlertService: {
    status: "ADDED",
    fraudAlerts: [
      {
        phoneNumber: "415-918-5555",
        status: "ADDED",
        stoppedDate: null,
      },
    ],
  },
  freeToEndUserServiceList: [
    {
      phoneId: "0000-0000-0000-0000",
      phoneNumber: "415-918-5555",
      carrier: "AT&T",
      status: "ADDED",
      updateDate: new Date(),
    },
    {
      phoneId: "0000-0000-0000-0001",
      phoneNumber: "415-918-5555",
      carrier: "VERIZON",
      status: "STOPPED",
      updateDate: new Date(),
    },
  ],
};

const MOCK_GET_RESULT_OPTIONS_CSR: ResultDropdowns = {
  contactPerson: [
    {
      id: "AUTH",
      value: "AUTH",
      description: "Auth User",
    },
    {
      id: "CM",
      value: "CM",
      description: "Cardmember",
    },
    {
      id: "OTHER",
      value: "OTHER",
      description: "Other",
    },
    {
      id: "PARENT",
      value: "PARENT",
      description: "Parent",
    },
  ],
  activity: [
    {
      id: "ACH",
      value: "ACH",
      description: "ACH",
    },
    {
      id: "ACQ",
      value: "ACQ",
      description: "Acquisitions",
    },
    {
      id: "ATHCHRGS",
      value: "ATH/CHRGS",
      description: "Auth/Chrgs",
    },
    {
      id: "AVLCRDBAL",
      value: "AVL CRD/BAL",
      description: "Avail Credit/Bal",
    },
    {
      id: "BS",
      value: "BS",
      description: "Brand Switch/AC",
    },
    {
      id: "CCAALERTS",
      value: "CREDIT CARD ALERTS",
      description: "Credit Card Alerts",
    },
    {
      id: "CHNGINFO",
      value: "CHNG ACCT INFO",
      description: "Chng Acct Info",
    },
    {
      id: "CIT",
      value: "CIT",
      description: "Chng in Terms",
    },
    {
      id: "CLS",
      value: "CLS",
      description: "Close",
    },
    {
      id: "CRDACTVT",
      value: "CRD ACTVT",
      description: "Card Activation",
    },
    {
      id: "CREDLINE",
      value: "CREDLINE",
      description: "Increase and Decrease to Credit Line",
    },
    {
      id: "CSHCNVCKPIN",
      value: "CASH/CONV CK/PIN",
      description: "Cash/Conv Ck/Pin",
    },
    {
      id: "DISC",
      value: "DISC",
      description: "Disconnected",
    },
    {
      id: "DSPT",
      value: "DSPT",
      description: "Dispute",
    },
    {
      id: "FEES",
      value: "FEES",
      description: "Fees",
    },
    {
      id: "LS",
      value: "LS",
      description: "Lost/Stolen",
    },
    {
      id: "LWRAPR",
      value: "LWR APR",
      description: "Lower APR",
    },
    {
      id: "OTHERS",
      value: "OTHERS",
      description: "Others",
    },
    {
      id: "PENPRCNG",
      value: "PEN PRCNG",
      description: "Penalty Pricing",
    },
    {
      id: "PHPYMT",
      value: "PH PYMT",
      description: "Phone Payment",
    },
    {
      id: "PLASEXPCRD",
      value: "PLAS/EXP CRD",
      description: "Plastic/Expired Crd",
    },
    {
      id: "PYMT",
      value: "PYMT",
      description: "Payment",
    },
    {
      id: "REIS",
      value: "REIS",
      description: "Reissue",
    },
    {
      id: "SECRTY",
      value: "SECRTY",
      description: "Security",
    },
    {
      id: "STMT",
      value: "STMT",
      description: "Statement",
    },
    {
      id: "TERMS",
      value: "TERMS",
      description: "Terms",
    },
    {
      id: "WEB",
      value: "WEB",
      description: "Web",
    },
  ],
  transferTo: [
    {
      id: "ACTVT",
      value: "ACTVT",
      description: "Activation/7690",
    },
    {
      id: "CENSVCS",
      value: "CEN SVCS",
      description: "Central Services/6750",
    },
    {
      id: "COLL",
      value: "COLL",
      description: "Collections",
    },
    {
      id: "CS",
      value: "CS",
      description: "Customer Service/7020",
    },
    {
      id: "DSPT",
      value: "DSPT",
      description: "Disputes/7528",
    },
    {
      id: "FDW",
      value: "FDW",
      description: "FDW/800-437-5681",
    },
    {
      id: "NOTRANS",
      value: "NO TRANS",
      description: "No transfer",
    },
    {
      id: "OTHER",
      value: "OTHER",
      description: "Other",
    },
    {
      id: "PIN",
      value: "PIN",
      description: "Mr Pin/800-337-1177",
    },
    {
      id: "SECRTY",
      value: "SECRTY",
      description: "Security/6777",
    },
    {
      id: "SUPQ",
      value: "SUP Q",
      description: "Sup Que/7666",
    },
    {
      id: "UW",
      value: "UW",
      description: "Underwriting/6640",
    },
  ],
  webActivity: [
    {
      id: "LOCKED",
      value: "LOCKED",
      description: "Locked",
    },
    {
      id: "OTP",
      value: "OTP",
      description: "One Time Passcode",
    },
    {
      id: "REG",
      value: "REG",
      description: "Registration",
    },
    {
      id: "USERNMPW",
      value: "USERNMPW",
      description: "Username/PW",
    },
  ],
};

const MOCK_RESULT_ACTION_CODES_PAYMENT: ResultOption[] = [
  {
    id: "AP",
    value: "AP",
    description: "AP (Arrangement to Pay)",
  },
  {
    id: "OC",
    value: "OC",
    description: "OC (Other Called)",
  },
  {
    id: "PC",
    value: "PC",
    description: "PC (Primary Called In)",
  },
  {
    id: "PP",
    value: "PP",
    description: "PP (Promise to Pay)",
  },
];

const MOCK_RESULT_PAYMENT_METHODS_PAYMENT: ResultOption[] = [
  {
    id: "B2CAGNT",
    value: "B2C AGNT",
    description: "B2C AGNT (B2C-Agent)",
  },
  {
    id: "B2CCB",
    value: "B2C CB",
    description: "B2C CB (B2C-Call Back)",
  },
  {
    id: "B2CVRU",
    value: "B2C VRU",
    description: "B2C VRU (B2C-VRU)",
  },
  {
    id: "C2C",
    value: "C2C",
    description: "C2C (Card to Card)",
  },
  {
    id: "C2CCB",
    value: "C2C/CB",
    description: "C2C/CB (Card to Card-Call Back)",
  },
  {
    id: "MAIL",
    value: "MAIL",
    description: "MAIL (US Mail)",
  },
  {
    id: "OTHER",
    value: "OTHER",
    description: "OTHER",
  },
  {
    id: "OVRNGT",
    value: "OVRNGT",
    description: "OVRNGT (Overnight)",
  },
  {
    id: "WEB",
    value: "WEB",
    description: "WEB (C2C / B2C - WEB)",
  },
  {
    id: "WIRE",
    value: "WIRE",
    description: "WIRE (Wire Transfer)",
  },
  {
    id: "WU",
    value: "WU",
    description: "WU (Western Union QC)",
  },
];

const MOCK_RESULT_ACTION_CODES_NOPAYMENT: ResultOption[] = [
  {
    id: "AP",
    value: "AP",
    description: "AP (Arrangement to Pay)",
  },
  {
    id: "IN",
    value: "IN",
    description: "IN (Information Received)",
  },
  {
    id: "LM",
    value: "LM",
    description: "LM (Left Message to Call)",
  },
  {
    id: "OC",
    value: "OC",
    description: "OC (Other Called)",
  },
  {
    id: "PC",
    value: "PC",
    description: "PC (Primary Called In)",
  },
  {
    id: "UP",
    value: "UP",
    description: "UP (Unable to Pay)",
  },
  {
    id: "UW",
    value: "UW",
    description: "UW (Unwilling to Pay)",
  },
];

const MOCK_RESULT_WHO_NOPAYMENT: ResultOption[] = [
  {
    id: "ATTY",
    value: "ATTY",
    description: "ATTY (Attorney)",
  },
  {
    id: "CCCS",
    value: "CCCS",
    description: "CCCS (Consumer Counseling)",
  },
  {
    id: "CM",
    value: "CM",
    description: "CM (CardMember)",
  },
  {
    id: "FML",
    value: "FML",
    description: "FML (Female)",
  },
  {
    id: "MALE",
    value: "MALE",
    description: "MALE",
  },
  {
    id: "OTHER",
    value: "OTHER",
    description: "OTHER",
  },
];

const MOCK_RESULT_OTHER_NOPAYMENT: ResultOption[] = [
  {
    id: "2X",
    value: "2X",
    description: "2X (2nd Pass)",
  },
  {
    id: "ACCTREV",
    value: "ACCTREV",
    description: "ACCTREV (Account Review)",
  },
  {
    id: "AM",
    value: "AM",
    description: "AM (Answering Machine)",
  },
  {
    id: "BSUPER",
    value: "BSUPER",
    description: "BSUPER (Inbound Supersede)",
  },
  {
    id: "DA",
    value: "DA",
    description: "DA (DeadAir)",
  },
  {
    id: "HU",
    value: "HU",
    description: "HU (Hang Up)",
  },
  {
    id: "MBF",
    value: "MBF",
    description: "MBF (Mailbox Full)",
  },
  {
    id: "NA",
    value: "NA",
    description: "NA (No Answer)",
  },
  {
    id: "NML",
    value: "NML",
    description: "NML (No Message Left)",
  },
  {
    id: "SYSMG ",
    value: "SYSMG ",
    description: "SYSMG  (System Message)",
  },
  {
    id: "WRNG#",
    value: "WRNG#",
    description: "WRNG# (Wrong Number)",
  },
  {
    id: "XFR",
    value: "XFR",
    description: "XFR (Transfer to Trained Rep)",
  },
];

const MOCK_GET_RESULT_OPTIONS_PAYMENT_INB: ResultDropdowns = {
  actionCode: MOCK_RESULT_ACTION_CODES_PAYMENT,
  contactPerson: [
    {
      id: "AUTH",
      value: "AUTH",
      description: "Auth User",
    },
    {
      id: "CM",
      value: "CM",
      description: "Cardmember",
    },
    {
      id: "OTHER",
      value: "OTHER",
      description: "Other",
    },
    {
      id: "PARENT",
      value: "PARENT",
      description: "Parent",
    },
  ],
  inboundCallReason: [
    {
      id: "CID",
      value: "CID",
      description: "CID (Caller ID)",
    },
    {
      id: "EMAIL",
      value: "EMAIL",
      description: "EMAIL",
    },
    {
      id: "FOLLOWUP",
      value: "FOLLOW UP",
      description: "FOLLOW UP",
    },
    {
      id: "LETTER",
      value: "LETTER",
      description: "LETTER",
    },
    {
      id: "LMAM",
      value: "LM AM",
      description: "LM AM (Msg Left on AM/Service)",
    },
    {
      id: "LMLIVE",
      value: "LM LIVE",
      description: "LM LIVE (Msg Left with Person)",
    },
    {
      id: "NORSN",
      value: "NO RSN",
      description: "NO RSN (Unprompted)",
    },
    {
      id: "TEXT",
      value: "TEXT",
      description: "TEXT",
    },
    {
      id: "WEB",
      value: "WEB",
      description: "WEB",
    },
  ],
  paymentMethod: MOCK_RESULT_PAYMENT_METHODS_PAYMENT,
};

const MOCK_GET_RESULT_OPTIONS_NOPAYMENT_INB: ResultDropdowns = {
  actionCode: MOCK_RESULT_ACTION_CODES_NOPAYMENT,
  contactPerson: [
    {
      id: "AUTH",
      value: "AUTH",
      description: "Auth User",
    },
    {
      id: "CM",
      value: "CM",
      description: "Cardmember",
    },
    {
      id: "NONE",
      value: "NONE",
      description: "None",
    },
    {
      id: "OTHER",
      value: "OTHER",
      description: "Other",
    },
    {
      id: "PARENT",
      value: "PARENT",
      description: "Parent",
    },
  ],
  inboundCallReason: [
    {
      id: "CID",
      value: "CID",
      description: "CID (Caller ID)",
    },
    {
      id: "EMAIL",
      value: "EMAIL",
      description: "EMAIL",
    },
    {
      id: "FOLLOWUP",
      value: "FOLLOW UP",
      description: "FOLLOW UP",
    },
    {
      id: "LETTER",
      value: "LETTER",
      description: "LETTER",
    },
    {
      id: "LMAM",
      value: "LM AM",
      description: "LM AM (Msg Left on AM/Service)",
    },
    {
      id: "LMLIVE",
      value: "LM LIVE",
      description: "LM LIVE (Msg Left with Person)",
    },
    {
      id: "NORSN",
      value: "NO RSN",
      description: "NO RSN (Unprompted)",
    },
    {
      id: "TEXT",
      value: "TEXT",
      description: "TEXT",
    },
    {
      id: "WEB",
      value: "WEB",
      description: "WEB",
    },
  ],
  other: MOCK_RESULT_OTHER_NOPAYMENT,
  who: MOCK_RESULT_WHO_NOPAYMENT,
};

const MOCK_GET_RESULT_OPTIONS_PAYMENT_TRN: ResultDropdowns = {
  actionCode: MOCK_RESULT_ACTION_CODES_PAYMENT,
  contactPerson: [
    {
      id: "AUTH",
      value: "AUTH",
      description: "Auth User",
    },
    {
      id: "CM",
      value: "CM",
      description: "Cardmember",
    },
    {
      id: "OTHER",
      value: "OTHER",
      description: "Other",
    },
    {
      id: "PARENT",
      value: "PARENT",
      description: "Parent",
    },
  ],
  paymentMethod: MOCK_RESULT_PAYMENT_METHODS_PAYMENT,
  transferSource: [
    {
      id: "COLL",
      value: "COLL",
      description: "COLL (Collector)",
    },
    {
      id: "CSR",
      value: "CSR",
      description: "CSR (Customer Service)",
    },
    {
      id: "ESC",
      value: "ESC",
      description: "ESC (Escalation)",
    },
    {
      id: "OTHER",
      value: "OTHER",
      description: "OTHER",
    },
    {
      id: "XFRTEAM",
      value: "XFR TEAM",
      description: "XFR TEAM (Transfer Team)",
    },
  ],
};

const MOCK_GET_RESULT_OPTIONS_NOPAYMENT_TRN: ResultDropdowns = {
  actionCode: MOCK_RESULT_ACTION_CODES_NOPAYMENT,
  contactPerson: [
    {
      id: "AUTH",
      value: "AUTH",
      description: "Auth User",
    },
    {
      id: "CM",
      value: "CM",
      description: "Cardmember",
    },
    {
      id: "NONE",
      value: "NONE",
      description: "None",
    },
    {
      id: "OTHER",
      value: "OTHER",
      description: "Other",
    },
    {
      id: "PARENT",
      value: "PARENT",
      description: "Parent",
    },
  ],
  other: MOCK_RESULT_OTHER_NOPAYMENT,
  transferSource: [
    {
      id: "COLL",
      value: "COLL",
      description: "COLL (Collector)",
    },
    {
      id: "CSR",
      value: "CSR",
      description: "CSR (Customer Service)",
    },
    {
      id: "ESC",
      value: "ESC",
      description: "ESC (Escalation)",
    },
    {
      id: "OTHER",
      value: "OTHER",
      description: "OTHER",
    },
    {
      id: "XFRTEAM",
      value: "XFR TEAM",
      description: "XFR TEAM (Transfer Team)",
    },
  ],
  who: MOCK_RESULT_WHO_NOPAYMENT,
};

const MOCK_GET_RESULT_OPTIONS_PAYMENT_OUT: ResultDropdowns = {
  actionCode: MOCK_RESULT_ACTION_CODES_PAYMENT,
  contactPerson: [
    {
      id: "AUTH",
      value: "AUTH",
      description: "Auth User",
    },
    {
      id: "CM",
      value: "CM",
      description: "Cardmember",
    },
    {
      id: "OTHER",
      value: "OTHER",
      description: "Other",
    },
    {
      id: "PARENT",
      value: "PARENT",
      description: "Parent",
    },
  ],
  paymentMethod: MOCK_RESULT_PAYMENT_METHODS_PAYMENT,
};

const MOCK_GET_RESULT_OPTIONS_NOPAYMENT_OUT: ResultDropdowns = {
  actionCode: MOCK_RESULT_ACTION_CODES_NOPAYMENT,
  contactPerson: [
    {
      id: "AUTH",
      value: "AUTH",
      description: "Auth User",
    },
    {
      id: "CM",
      value: "CM",
      description: "Cardmember",
    },
    {
      id: "NONE",
      value: "NONE",
      description: "None",
    },
    {
      id: "OTHER",
      value: "OTHER",
      description: "Other",
    },
    {
      id: "PARENT",
      value: "PARENT",
      description: "Parent",
    },
  ],
  other: MOCK_RESULT_OTHER_NOPAYMENT,
  who: MOCK_RESULT_WHO_NOPAYMENT,
};

const MOCK_GET_RESULT_OPTIONS_PAYMENT_RES: ResultDropdowns = {
  actionCode: MOCK_RESULT_ACTION_CODES_PAYMENT,
  contactPerson: [
    {
      id: "AUTH",
      value: "AUTH",
      description: "Auth User",
    },
    {
      id: "CM",
      value: "CM",
      description: "Cardmember",
    },
    {
      id: "OTHER",
      value: "OTHER",
      description: "Other",
    },
    {
      id: "PARENT",
      value: "PARENT",
      description: "Parent",
    },
  ],
  paymentMethod: MOCK_RESULT_PAYMENT_METHODS_PAYMENT,
};

const MOCK_GET_RESULT_OPTIONS_NOPAYMENT_RES: ResultDropdowns = {
  actionCode: MOCK_RESULT_ACTION_CODES_NOPAYMENT,
  contactPerson: [
    {
      id: "AUTH",
      value: "AUTH",
      description: "Auth User",
    },
    {
      id: "CM",
      value: "CM",
      description: "Cardmember",
    },
    {
      id: "NONE",
      value: "NONE",
      description: "None",
    },
    {
      id: "OTHER",
      value: "OTHER",
      description: "Other",
    },
    {
      id: "PARENT",
      value: "PARENT",
      description: "Parent",
    },
  ],
  correspondenceReason: [
    {
      id: "3RDPERM",
      value: "3RD PERM",
      description: "3RD PERM (3rd Party Permission)",
    },
    {
      id: "BK",
      value: "BK",
      description: "BK (Bankruptcy)",
    },
    {
      id: "CCCS",
      value: "CCCS",
      description: "CCCS (CCCS Proposal)",
    },
    {
      id: "DBTSTTL",
      value: "DBTSTTL",
      description: "DBTSTTL (Debt Settlement Company)",
    },
    {
      id: "DEATH",
      value: "DEATH",
      description: "DEATH (Death Certificate)",
    },
    {
      id: "EXCLTR",
      value: "EXC LTR",
      description: "EXC LTR (Executive Letter)",
    },
    {
      id: "OTHER",
      value: "OTHER",
      description: "OTHER",
    },
    {
      id: "POA",
      value: "POA",
      description: "POA (Power of Attorney)",
    },
  ],
  other: MOCK_RESULT_OTHER_NOPAYMENT,
  who: MOCK_RESULT_WHO_NOPAYMENT,
};

export const MOCK_GET_RESULT_OPTIONS_INB: ResultsDropdownsByChannel = {
  csrOptions: MOCK_GET_RESULT_OPTIONS_CSR,
  paymentOptions: MOCK_GET_RESULT_OPTIONS_PAYMENT_INB,
  noPaymentOptions: MOCK_GET_RESULT_OPTIONS_NOPAYMENT_INB,
};

export const MOCK_GET_RESULT_OPTIONS_TRN: ResultsDropdownsByChannel = {
  csrOptions: MOCK_GET_RESULT_OPTIONS_CSR,
  paymentOptions: MOCK_GET_RESULT_OPTIONS_PAYMENT_TRN,
  noPaymentOptions: MOCK_GET_RESULT_OPTIONS_NOPAYMENT_TRN,
};

export const MOCK_GET_RESULT_OPTIONS_OUT: ResultsDropdownsByChannel = {
  csrOptions: MOCK_GET_RESULT_OPTIONS_CSR,
  paymentOptions: MOCK_GET_RESULT_OPTIONS_PAYMENT_OUT,
  noPaymentOptions: MOCK_GET_RESULT_OPTIONS_NOPAYMENT_OUT,
};

export const MOCK_GET_RESULT_OPTIONS_RES: ResultsDropdownsByChannel = {
  csrOptions: MOCK_GET_RESULT_OPTIONS_CSR,
  paymentOptions: MOCK_GET_RESULT_OPTIONS_PAYMENT_RES,
  noPaymentOptions: MOCK_GET_RESULT_OPTIONS_NOPAYMENT_RES,
};

export const MOCK_GET_NOTES_SEARCH: GetNotesSearchResponse = {
  notes: [
    {
      accountNumberLast: "1234",
      agent: "_WB",
      channel: "WEB",
      content: "This is a note",
      dwbuid: 123456789,
      noteDate: "2026-07-17",
      noteId: "9876",
      detailId: "9876",
      partyId: 302010,
      priority: "CRITICAL",
      source: "CLARITY",
    },
    {
      accountNumberLast: "1111",
      agent: "_WB",
      channel: "RESEARCH",
      content: "This is another note",
      dwbuid: 123456700,
      noteDate: "2026-07-20",
      noteId: "9877",
      detailId: "9877",
      partyId: 302010,
      priority: "REGULAR",
      source: "ACQ",
    },
    {
      accountNumberLast: "1234",
      agent: "_WB",
      channel: "WEB",
      content:
        "This is a really long note such that it will be forced to wrap to another line for style-checking purposes",
      dwbuid: 123456700,
      noteDate: "2026-07-20",
      noteId: "9878",
      detailId: "9878",
      partyId: 302010,
      priority: "REGULAR",
      source: "CLARITY",
    },
    {
      accountNumberLast: "1234",
      agent: "_WB",
      channel: "INBOUND",
      content: "This is another note",
      dwbuid: 123456700,
      noteDate: "2026-07-18",
      noteId: "9879",
      detailId: "9879",
      partyId: 302010,
      priority: "REGULAR",
      source: "CHGBCK",
    },
    {
      accountNumberLast: "2222",
      agent: "_WB",
      channel: "WEB",
      content: "This is another note",
      dwbuid: 123456700,
      noteDate: "2026-07-20",
      noteId: "9880",
      detailId: "9880",
      partyId: 302010,
      priority: "REGULAR",
      source: "CLARITY",
    },
    {
      accountNumberLast: "1234",
      agent: "_MA",
      channel: "WEB",
      content:
        "This is a really long note such that it will be forced to wrap to another line for style-checking purposes",
      dwbuid: 123456700,
      noteDate: "2026-07-21",
      noteId: "9881",
      detailId: "9881",
      partyId: 302010,
      priority: "REGULAR",
      source: "CLARITY",
    },
    {
      accountNumberLast: "3333",
      agent: "_WB",
      channel: "TRANSFER",
      content: "A note",
      dwbuid: 123456700,
      noteDate: "2026-07-20",
      noteId: "9882",
      detailId: "9882",
      partyId: 302010,
      priority: "REGULAR",
      source: "MAID",
    },
    {
      accountNumberLast: "1235",
      agent: "_MA",
      channel: "WEB",
      content:
        "This is a really long note such that it will be forced to wrap to another line for style-checking purposes",
      dwbuid: 123456700,
      noteDate: "2026-07-18",
      noteId: "9883",
      detailId: "9883",
      partyId: 302010,
      priority: "REGULAR",
      source: "CLARITY",
    },
    {
      accountNumberLast: "1240",
      agent: "_WB",
      channel: "WEB",
      content:
        "This is a really long note such that it will be forced to wrap to another line for style-checking purposes",
      dwbuid: 123456700,
      noteDate: "2026-07-18",
      noteId: "9884",
      detailId: "9884",
      partyId: 302010,
      priority: "REGULAR",
      source: "CLARITY",
    },
  ],
  sourceTypeOptions: [
    { id: "CLARITY", value: "CLARITY" },
    { id: "PRICE", value: "PRICE" },
  ],
  channelOptions: [
    { id: "INBOUND", value: "Inbound" },
    { id: "OUTBOUND", value: "Outbound" },
  ],
};

export const MOCK_GET_NOTES_SEARCH_EMPTY: GetNotesSearchResponse = {
  ...MOCK_GET_NOTES_SEARCH,
  notes: [],
};

export const MOCK_GET_NOTE_DETAILS: NoteDetail = {
  accountContent: {
    agentFdrCode: "1234",
    agentFirstName: "John",
    agentLastName: "Doe",
    amountDelinquentCents: 20000,
    amountDueCents: 30000,
    behaviorCreditBureauScore: "600",
    contactId: 1234,
    creditLimitCents: 700000,
    cureIndicator: null,
    currentBalanceCents: 40000,
    nextCycleDate: "2026-07-20",
    currentMonthlyPaymentCents: 50000,
    cycleCode: 1234,
    daysDelinquent: 20,
    delinquentBucket1Cents: 10000,
    delinquentBucket2Cents: 0,
    delinquentBucket3Cents: 0,
    delinquentBucket4Cents: 0,
    delinquentBucket5Cents: 0,
    delinquentBucket6Cents: 0,
    delinquentBucket7Cents: 0,
    delinquentBucket: "100.00",
    fixedPaymentAmountCents: 2000,
    internalExternalStatus: "",
    lastStatementBalanceCents: 50000,
    location: "",
    oclAmountCents: 4180,
    paperlessDescription: "",
    paperlessFlag: true,
    paymentDueDate: "2026-07-20",
    permCollectorCode: "1234",
    pricing: null,
    pricingControlCure: "",
    referenceId: "1234",
    statementHoldCode: "",
    tempCollectorCode: "",
    totalAmountDueCents: 10000,
    unitPricingControl12: null,
  },
  createDate: "2026-07-20",
  dwbuid: 9876,
  noteId: "123456",
  partyId: 1234,
  resultContent: {
    actionEntry: "",
    actionEntryToPost: "",
    actionNote: "",
    amountDueCents: 10000,
    confirmationNumber: "123",
    contactDetailType: "",
    contactType: "",
    correspondenceReason: "",
    currentBalanceCents: 10000,
    cycleCode: 123456,
    daysDelinquent: 20,
    delinquentBucketId: 1234,
    dwbuid: "123456789",
    inboundReason: "",
    lastStatementBalanceCents: 50000,
    letterType: "",
    nextWorkDate: "2026-07-20",
    noteContent: "This is a note",
    otherOrWhat: "",
    paymentAmountToBePostedCents: 0,
    paymentDueDate: "2026-07-20",
    paymentMethod: "",
    paymentMethodDate: "2026-07-20",
    primaryName: "",
    promiseToPayDate: "2026-07-20",
    rolls: 0,
    transferSource: "",
  },
  resultDate: "2026-07-20",
  resultType: "",
};

export const MOCK_GET_NOTE_DETAILS_MAX_EMPTY: NoteDetail = {
  accountContent: {
    agentFdrCode: "1234",
    agentFirstName: "John",
    agentLastName: "Doe",
    amountDelinquentCents: 20000,
    amountDueCents: 30000,
    behaviorCreditBureauScore: "600",
    contactId: 1234,
    creditLimitCents: 700000,
    cureIndicator: null,
    currentBalanceCents: 40000,
    nextCycleDate: "2026-07-20",
    currentMonthlyPaymentCents: 50000,
    cycleCode: 1234,
    daysDelinquent: 20,
    delinquentBucket1Cents: null,
    delinquentBucket2Cents: null,
    delinquentBucket3Cents: null,
    delinquentBucket4Cents: null,
    delinquentBucket5Cents: null,
    delinquentBucket6Cents: null,
    delinquentBucket7Cents: null,
    delinquentBucket: "100.00",
    fixedPaymentAmountCents: 2000,
    internalExternalStatus: "",
    lastStatementBalanceCents: null,
    location: null,
    oclAmountCents: 4180,
    paperlessDescription: null,
    paperlessFlag: true,
    paymentDueDate: null,
    permCollectorCode: null,
    pricing: null,
    pricingControlCure: null,
    referenceId: null,
    statementHoldCode: null,
    tempCollectorCode: null,
    totalAmountDueCents: 10000,
    unitPricingControl12: null,
  },
  createDate: "2026-07-20",
  dwbuid: 9876,
  noteId: "123456",
  partyId: 1234,
  resultContent: {
    actionEntry: null,
    actionEntryToPost: null,
    actionNote: null,
    amountDueCents: null,
    confirmationNumber: "",
    contactDetailType: null,
    contactType: "",
    correspondenceReason: null,
    currentBalanceCents: null,
    cycleCode: null,
    daysDelinquent: null,
    delinquentBucketId: null,
    dwbuid: "1234",
    inboundReason: null,
    lastStatementBalanceCents: null,
    letterType: null,
    nextWorkDate: null,
    noteContent: "string",
    otherOrWhat: null,
    paymentAmountToBePostedCents: null,
    paymentDueDate: null,
    paymentMethod: null,
    paymentMethodDate: null,
    primaryName: "string",
    promiseToPayDate: null,
    rolls: null,
    transferSource: null,
  },
  resultDate: null,
  resultType: null,
};

export const MOCK_GET_LISTEN_RESPONSE: ListenResponse = {
  customerCallContext: {
    id: 1,
    callCampaign: "Campaign Name Here",
    callId: "12",
    channel: "Inbound",
    dwbuid: "unpopulated",
    employeeId: "000111",
    phoneNumber: "5121231234",
    startTime: new Date("2026-07-01T04:41:00.000Z"),
  },
};

export const MOCK_GET_PARTIAL_LISTEN_RESPONSE: ListenResponse = {
  customerCallContext: {
    id: 1,
    callCampaign: "Campaign Name Here",
    callId: "12",
    channel: "Inbound",
    dwbuid: "",
    employeeId: "000111",
    phoneNumber: "5121231234",
    startTime: new Date("2026-07-01T04:41:00.000Z"),
  },
};
